import moment = require("moment");
import { IIbanObject } from "../modules/athora/athora.constants";
import { IVariazioneModPagamentoRequest } from "../modules/athora/components/bank-account-update/bank-account-update.constants";
import { ESpecificBeneficiaryType } from "../modules/athora/components/beneficiary-form/beneficiary-form.constants";
import { IAnnulloOperazione } from "../modules/athora/components/cancel-operation/cancel-operation.constants";
import { IAdditionalPaymentRequest, IAdditionalPaymentRequestIsv, vagg_operation_data_form_validators } from "../modules/isv/components/additional-payment/additional-payment.constants";
import { IBankAccountChangeIsvRequest } from "../modules/isv/components/bank-account-change-isv/bank-account-change-isv.constants";
import { EBeneficiaryTypeIsv, IBeneficiaryChangeRequest, IDebitDateVariation, IDocumentUpdate, ILifeDeathBeneficiary, IPayerVariationUpdate, IPersonDataIsv, IRetirementDateVariation } from "../modules/isv/components/beneficiary-change-isv/beneficiary-change-isv.constants";
import { IBranchOfficeChangeRequest } from "../modules/isv/components/branch-office-variation/branch-office-variation.constants";
import { ISwitchLifeInvestmentsRequest, ISwitchPrevidentialInvestmentsRequest, PrevidentialInvestedFund, PrevidentialInvestmentMovement } from "../modules/isv/components/branch-switch-investment-intesa/branch-switch-investment-intesa.constants";
import { IComunicazioneSinistroRequest } from "../modules/isv/components/claim-notification-isv/claim-notification-isv.constants";
import { IIsvCessioneContraenzaRequest, vcont_operation_data_form_validators } from "../modules/isv/components/contractor-change-isv/contractor-change-isv.constants";
import { IDocumentChangeRequest } from "../modules/isv/components/document-change/document-change.constants";
import { IIsvRiscattoParzialeRequest } from "../modules/isv/components/partial-redeem-isv/partial-redeem-isv.constants";
import { IRegistryAdjustmentRequest } from "../modules/isv/components/registry-adjustment/registry-adjustment.constants";
import { IResidenceChangeRequest } from "../modules/isv/components/residence-change-isv/residence-change-isv.constants";
import { FractionsDomainPrevidenziali, gianos_operation_data_form_template, IAnagraficaRelazioneContraente, IGenericListIsv, IGianosAdequateVerification, IGianosDatiOperatore, IGianosDesignazioneBeneficiari, IGianosEsecutoreConto, IGianosFunsList, IGianosHoldersRelationship, IGianosOperationInfo, IGianosPaymentMode, IGianosPolicyHolder, IGianosPolicyInsured, IGianosPrivacy, IGianosTitolareEffettivo, IIntesaFormFieldsObj, IIntesaFormFieldsResponse, INationPrevidential, IPersonIntestaFormGroups, IProvincePrevidential, IStoricoComunePrevidential } from "../modules/isv/isv.constants";
import { EVariationOptions, IVariazionePremioPeriodicitaPrevidentialRequest, IVariazionePremioPeriodicitaRequest } from "../modules/shared/components/frequency-premium-change/frequency-premium-change.constants";
import { IIsvLiquidazioneScadenzaRequest, liquidation_maturity_operation_data_form_validators } from "../modules/shared/components/liquidation-maturity/liquidation-maturity.constants";
import { ISospensionePagamentiRequest } from "../modules/shared/components/premium-payment-suspension/premium-payment-suspension.constants";
import { IIsvRiscattoTotaleRequest, risto_operation_data_form_validators } from "../modules/shared/components/total-redeem/total-redeem.constants";
import { IFormSelectOption } from "../modules/shared/models/forms";
import { IBeneficiarioPrevidenziale, IFigureAnagrafiche, IInvestmentLine, ILegalPersonIntesa, IPagatore, IPersonIntesa, IPolicyAsset, IPolicyDetail, IPolicyDetailSubject, RegistryType } from "../modules/shared/models/policy.model";
import { AthoraPayloadUtils } from "./AthoraPayloadUtils";
import { CommonUtils } from "./CommonUtils";
import { IChangeLineInvestmentRequest } from "../modules/isv/components/change-investment-line-isv/change-investment-line-isv.constants";
import { FundObject, IChangeLineInvestmentPrevidentialRequest } from "../modules/isv/components/change-investment-line-isp/change-investment-line-isp.constants";
import { EmployerTableRow, ISpostamentoIscrittoRequest } from "../modules/isv/components/spostamento-iscritto/spostamento-iscritto.constants";

export class IsvUtils {
    static manageIsvFormInfoPrevidential(
        isvFormInfo: IIntesaFormFieldsResponse,
        draft?: string
    ): IIntesaFormFieldsObj {
        let output: IIntesaFormFieldsObj = { };

        const storicoComuni: IStoricoComunePrevidential[] = CommonUtils.checkAndGet(isvFormInfo, 'storicoComuni.storicoComuni', []);
        if (storicoComuni) {
          output.comuniList = storicoComuni.map(obj => ({
            key: obj.cComune,
            value: obj.descrizione,
            valueForMapping: obj.cProvincia
          }))
        }

        const provinceList: IProvincePrevidential[] = CommonUtils.checkAndGet(isvFormInfo, 'province.province', []);
        if (provinceList) {
          output.provincesList = provinceList.map(obj => ({
            key: obj.c_provincia,
            value: obj.descrizione
          }))
        }

        const frequenciesList: FractionsDomainPrevidenziali[] = CommonUtils.checkAndGet(isvFormInfo, 'frazionamentiDomain', [])
        if (frequenciesList) {
          output.frequenciesList = frequenciesList.map((fraction) => ({
            key: fraction.c_frazionamento,
            value: fraction.descrizione
          }))
        }

        const currentInstallmentAmount: string = CommonUtils.checkAndGet(isvFormInfo, 'currentInstallmentAmount', null)
        if (currentInstallmentAmount) {
          output.currentInstallmentAmount = currentInstallmentAmount
        }

        const currentFrequency: string = CommonUtils.checkAndGet(isvFormInfo, 'currentFrequency', null)
        if (currentFrequency) {
          output.currentFrequency = currentFrequency
        }

        const countriesList: INationPrevidential[] = CommonUtils.checkAndGet(isvFormInfo, 'nazioni.nazioni', []);
        if (countriesList) {
          output.countriesList = countriesList.map(obj => ({
            key: obj.c_nazione,
            value: obj.descrizione
          }))
        }

        if (!draft) {
          const currentEmployersData: EmployerTableRow = CommonUtils.checkAndGet(isvFormInfo, 'currentEmployerData', {});
          const employersDataFields = Object.values(currentEmployersData)
          if (currentEmployersData && employersDataFields.some(value => value !== null)) {
            output.currentEmployersData = [currentEmployersData];
          } else {
            output.currentEmployersData = [];
          }
        }

        const anagraficaRelazioneContraenteBeneficiario: IAnagraficaRelazioneContraente[] = CommonUtils.checkAndGet(isvFormInfo, 'anagraficaRelazioneContraenteBeneficiario.anagraficaRelazioneContraenteBeneficiario', []);
        if (anagraficaRelazioneContraenteBeneficiario) {
          output.holderBeneficiaryRelationshipList = anagraficaRelazioneContraenteBeneficiario.map(obj => ({
            key: obj.c_relazione,
            value: obj.descrizione
          }))
        }

        const tipoBeneficiario: any[] = CommonUtils.checkAndGet(isvFormInfo, 'tipoBeneficiario.tipoBeneficiario', []);
        if (tipoBeneficiario) {
          output.previdentialBeneficiariesTypes = tipoBeneficiario.map(obj => ({
            key: obj.c_beneficiario,
            value: obj.descrizione,
            valueForMapping: obj.c_tipo_beneficiario
          }))
        }

        const dettaglioBeneficiari: any[] = CommonUtils.checkAndGet(isvFormInfo, 'dettaglioBeneficiari.dettaglioBeneficiari', []);
        if (dettaglioBeneficiari) {
          output.previdentialBeneficiariesList = dettaglioBeneficiari
        }

        const retirementDate: string = CommonUtils.checkAndGet(isvFormInfo, 'datiGenerali.dataScadenza', null);
        if (retirementDate) {
          output.retirementDate = moment(retirementDate).format('YYYY-MM-DD');
        }

        const debitDate: any[] = CommonUtils.checkAndGet(isvFormInfo, 'datiPolizzaSP', null);
        if (debitDate && debitDate.length > 0) {
          const currentDebitDate = debitDate[0].dataVersamento;
          output.debitDate = moment(currentDebitDate).format('YYYY-MM-DD');
        }

        const datiPolizzaSP: any[] = CommonUtils.checkAndGet(isvFormInfo, 'datiPolizzaSP.datiPolizzaSP', [])
        if (datiPolizzaSP && datiPolizzaSP.length > 0) {
          output.iscritto = datiPolizzaSP[0].anagraficoContraente
        }

        const figureAnagrafiche: IFigureAnagrafiche[] = CommonUtils.checkAndGet(isvFormInfo, 'figureAnagrafiche.figureAnagrafiche', [])
        if (figureAnagrafiche && figureAnagrafiche.length > 0) {
          output.figureAnagrafiche = figureAnagrafiche
        }

        const payersList: IPagatore[] = CommonUtils.checkAndGet(isvFormInfo, 'dettaglioPagatore.pagatore', []);
        if( payersList && payersList.length > 0) {
          output.payersList = payersList
        }

        const documentReleaseAuthorityList: any[] = CommonUtils.checkAndGet(isvFormInfo, 'entiRilascioDocumenti.entiRilascioDocumenti', []);
        if (documentReleaseAuthorityList && documentReleaseAuthorityList.length > 0) {
          output.documentReleaseAuthorities = documentReleaseAuthorityList.map(obj => ({
            key: obj.cEnteRilascioDocumento,
            value: obj.descrizione.trim()
          }));
        }

        const documentTypesList: any[] = CommonUtils.checkAndGet(isvFormInfo, 'tipiDocumentoRiconoscimento.documentiRiconoscimento', []);
        if (documentTypesList && documentTypesList.length > 0) {
          output.documentTypesDomain = documentTypesList.map(obj => ({
            key: obj.codiceDocumentoRiconoscimento,
            value: obj.descrizione.trim()
          }));
        }

        const activeFunds: IPolicyAsset[] = CommonUtils.checkAndGet(isvFormInfo, 'activeFunds', []);
        if (activeFunds && activeFunds.length > 0) {
            output.activeFunds = activeFunds.map(fund => ({
                fundCode: CommonUtils.checkAndGet(fund, 'codiceFondo', null),
                description: CommonUtils.checkAndGet(fund, 'descrizione', null),
                quoteNumber: CommonUtils.checkAndGet(fund, 'totaleQuote', null),
                quoteValue: CommonUtils.checkAndGet(fund, 'quotazione', null),
                quoteValueUpdateDate: moment(CommonUtils.checkAndGet(fund, 'dataQuotazione', null))?.format('DD/MM/YYYY'),
                assuranceCode: CommonUtils.checkAndGet(fund, 'codiceGaranzia', null),
                fundAmount: Number(CommonUtils.checkAndGet(fund, 'controvalore', 0))?.toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }),
                TFRAllocation: CommonUtils.checkAndGet(fund, 'allocazioneTFR', "0"),
                companyAllocation: CommonUtils.checkAndGet(fund, 'allocazioneAzienda', "0"),
                subscriberAllocation: CommonUtils.checkAndGet(fund, 'allocazioneIscritto', "0"),
                selected: false,
                amount: "0"
            }))
        }
        const investmentFunds: IPolicyAsset[] = CommonUtils.checkAndGet(isvFormInfo, 'investmentFunds', []);
        if (investmentFunds && investmentFunds.length > 0) {
            output.investmentFunds = investmentFunds.map(fund => ({
                fundCode: CommonUtils.checkAndGet(fund, 'cFondo', null),
                description: CommonUtils.checkAndGet(fund, 'descrizione', null),
                currentInvestedValue: Number(CommonUtils.checkAndGet(fund, 'controvalore', 0))?.toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }),
                quoteValueUpdateDate: moment(CommonUtils.checkAndGet(fund, 'dRiferimento', null))?.format('DD/MM/YYYY'),
                quoteValue: CommonUtils.checkAndGet(fund, 'iQuotazione', null),
                quoteNumber: "0",
                pInvestment: "0",
                TFRAllocation: CommonUtils.checkAndGet(fund, 'allocazioneTFR', "0"),
                companyAllocation: CommonUtils.checkAndGet(fund, 'allocazioneAzienda', "0"),
                subscriberAllocation: CommonUtils.checkAndGet(fund, 'allocazioneIscritto', "0"),
            }))
        }

        let currentLine: any = CommonUtils.checkAndGet(isvFormInfo, 'currentLine', []);
        if (currentLine) {
            currentLine = {
                code: CommonUtils.checkAndGet(currentLine, 'codiceTipoLineaInvestimento', null),
                description: CommonUtils.checkAndGet(currentLine, 'descrizione', null),
                selected: true,
                funds: CommonUtils.checkAndGet(currentLine, 'fundsList', []).map(fund => ({
                    fundCode: fund.codiceFondo,
                    fundAmount: fund.controvalore,
                    description: fund.descrizione,
                    quoteValue: fund.quotazione,
                    quoteNumber: fund.totaleQuote,
                    quoteValueUpdateDate: moment(fund.dataQuotazione)?.format('DD/MM/YYYY'),
                    TFRAllocation: CommonUtils.checkAndGet(fund, 'allocazioneTFR', "0"),
                    companyAllocation: CommonUtils.checkAndGet(fund, 'allocazioneAzienda', "0"),
                    subscriberAllocation: CommonUtils.checkAndGet(fund, 'allocazioneIscritto', "0"),
                })),
            }
        }

        let destinationLines: any[] = CommonUtils.checkAndGet(isvFormInfo, 'destinationLines', []);
        if (destinationLines) {
            destinationLines = destinationLines.map(obj => ({
                code: CommonUtils.checkAndGet(obj, 'codiceTipoLineaInvestimento', null),
                description: CommonUtils.checkAndGet(obj, 'descrizione', null),
                selected: false,
                funds: obj.fundsList.map(fund => ({
                    fundCode: fund.cFondo,
                    description: fund.descrizione,
                    quoteValue: fund.iQuotazione,
                    quoteValueUpdateDate: moment(fund.dRiferimento)?.format('DD/MM/YYYY'),
                    TFRAllocation: CommonUtils.checkAndGet(fund, 'allocazioneTFR', "0"),
                    companyAllocation: CommonUtils.checkAndGet(fund, 'allocazioneAzienda', "0"),
                    subscriberAllocation: CommonUtils.checkAndGet(fund, 'allocazioneIscritto', "0"),
                })),
            }));
        }
        output.lines = [currentLine, ...destinationLines]

        let documentiAnagrafica: IDocumentUpdate[] = CommonUtils.checkAndGet(isvFormInfo, 'documentiAnagrafica', []);
        output.previousDocuments = documentiAnagrafica

        return output
    }


    // region FORM
    static manageIsvFormInfo(
        isvFormInfo: IIntesaFormFieldsResponse,
        contractorTypeDescription: any,
        canOverWriteFunds: boolean = true,
    ): IIntesaFormFieldsObj {
        let output: IIntesaFormFieldsObj = { };
        output.productCategory = CommonUtils.checkAndGet(isvFormInfo, 'gianosData.operazione.categoriaProdotto', null);
        output.reportScope = CommonUtils.checkAndGet(isvFormInfo, 'gianosData.operazione.scopoRapporto', null);
        const documentTypes = CommonUtils.checkAndGet(isvFormInfo, 'documentTypes', []);
        if (documentTypes) {
          output.documentTypeList = documentTypes.map(document => ({
            key: document.code,
            value: document.description
          }));
        }
        const tableValues = CommonUtils.checkAndGet(isvFormInfo, 'documentiAnagrafica', []);
        if (tableValues) {
          output.tableValues = tableValues
        }
        const agreementPurposes: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'agreementPurposes', []);
        if (agreementPurposes) {
          output.agreementPurposeList = agreementPurposes.map(obj => ({
            key: obj.code,
            value: obj.description

          }));
        }
        const operationPurposeObj = CommonUtils.checkAndGet(isvFormInfo, 'operationPurposeList', []);
        const contractorType: string = contractorTypeDescription === 'Giuridica' ? 'PG' : 'PF';
        const operationPurposeList: IGenericListIsv[] = operationPurposeObj[contractorType];
        if (operationPurposeList) {
          output.operationPurposeList = operationPurposeList.map(obj => ({
            key: obj.code,
            value: obj.description
          }));
        }
        const customerBehaviours = CommonUtils.checkAndGet(isvFormInfo, 'customerBehaviours', []);
        if (customerBehaviours) {
          output.customerBehaviourList = customerBehaviours.map(key => ({
            key: key,
            value: key
          }));
        }
        const fundsOrigin = CommonUtils.checkAndGet(isvFormInfo, 'fundsOrigin', []);
        if (fundsOrigin) {
          output.fundsOriginList = fundsOrigin.map(key => ({
            key: key,
            value: key
          }));
        }
        const incomeLevels = CommonUtils.checkAndGet(isvFormInfo, 'incomeLevels', []);
        if (incomeLevels) {
          output.incomeLevelsList = incomeLevels.map(key => ({
            key: key,
            value: key
          }));
        }
        const documentReleaseAuthoritiesUni30 = CommonUtils.checkAndGet(isvFormInfo, 'releaseAuthorityDomain', []);
        if (documentReleaseAuthoritiesUni30) {
          output.documentReleaseAuthorities = documentReleaseAuthoritiesUni30.map(key => ({
            key: key.cEnteRilascioDocumento,
            value: key.descrizione.trim()
          }));
        }
        const clientsExistingDocuments = CommonUtils.checkAndGet(isvFormInfo, 'documentiAnagrafica', []);
        const documentTypesDomainUni30 = CommonUtils.checkAndGet(isvFormInfo, 'documentsDomain', []);
        if (documentTypesDomainUni30) {
          output.documentTypesDomain = documentTypesDomainUni30
            .filter((docType) =>
              clientsExistingDocuments.find(
                (existingDoc) =>
                  existingDoc.codiceDocumentoRiconoscimento ===
                  docType.codiceDocumentoRiconoscimento
              )
            )
            .map((key) => ({
              key: key.codiceDocumentoRiconoscimento,
              value: key.descrizione.trim(),
            }));
        }
        const executionModeList = CommonUtils.checkAndGet(isvFormInfo, 'longTermPolicyRelationshipExecutionModes', []);
        if (executionModeList) {
          output.executionModeList = executionModeList.map(key => ({
            key: key,
            value: key
          }));
        }
        const operationExecutionModeList = CommonUtils.checkAndGet(isvFormInfo, 'operationExecutionModes', []);
        if (operationExecutionModeList) {
          output.operationExecutionModeList = operationExecutionModeList.map(key => ({
            key: key,
            value: key
          }));
        }
        const presenceInExternalList = CommonUtils.checkAndGet(isvFormInfo, 'presenceInExternalLists', []);
        if (presenceInExternalList) {
          output.presenceInExternalList = presenceInExternalList.map(key => ({
            key: key,
            value: key
          }));
        }
        const professionsList = CommonUtils.checkAndGet(isvFormInfo, 'professionsList', []);
        if (professionsList) {
          output.professionsList = professionsList.map(key => ({
            key: key.code,
            value: key.description
          }));
        }
        const chargeTypes = CommonUtils.checkAndGet(isvFormInfo, 'chargeTypes', []);
        if (chargeTypes) {
          output.chargeTypes = chargeTypes.map(key => ({
            key: key.code,
            value: key.description
          }));
        }
        const incomeBracketsList = CommonUtils.checkAndGet(isvFormInfo, 'incomeBracketsList', []);
        if (incomeBracketsList) {
          output.incomeBracketsList = incomeBracketsList.map(key => ({
            key: key.code,
            value: key.description
          }));
        }
        const productCategoriesList: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'productCategories', []);
        if (productCategoriesList) {
          output.productCategoriesList = productCategoriesList.map(obj => ({
            key: obj.code,
            value: obj.description
          }));
        }
        const riscattoTypesList = CommonUtils.checkAndGet(isvFormInfo, 'riscattoTypes', []);
        if (riscattoTypesList) {
          output.riscattoTypesList = riscattoTypesList.map(key => ({
            key: key,
            value: key
          }));
        }
        const versamentoTypesList = CommonUtils.checkAndGet(isvFormInfo, 'versamentoTypes', []);
        if (versamentoTypesList) {
          output.versamentoTypesList = versamentoTypesList.map(key => ({
            key: key,
            value: key
          }));
        }
        const documentationList = CommonUtils.checkAndGet(isvFormInfo, 'documentationList', []);
        if (documentationList) {
          output.documentationList = documentationList.map(key => ({
            key: key,
            value: key
          }));
        }
        const documentReleaseAuthority = CommonUtils.checkAndGet(isvFormInfo, 'documentReleaseAuthority', []);
        if (documentReleaseAuthority && documentTypes) {
          output.documentReleaseAuthorityList = Object.keys(documentReleaseAuthority).map((key) => ({
            key: key,
            value: documentReleaseAuthority[key]
          }));
        }
        const saeList: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'saeList', []);
        if (saeList) {
          output.saeList = saeList.map(obj => ({
            key: obj.code,
            value: obj.description
          }))
        }
        const taeList: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'taeCodes', []);
        if (taeList) {
          output.taeList = taeList.map(obj => ({
            key: obj.code,
            value: obj.description
          }))
        }
        const beneficiariesClassification: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'beneficiariesClassification', []);
        if (beneficiariesClassification) {
          output.beneficiariesClassification = beneficiariesClassification.map(key => ({
            key: key,
            value: key
          }))
        }
        const businessTypes: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'businessTypes', []);
        if (businessTypes) {
          output.businessTypes = businessTypes.map(key => ({
            key: key,
            value: key
          }))
        }
        const relazioneContraenteBeneficiario: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'beneficiaryRelationshipWithHolder', []);
        if (relazioneContraenteBeneficiario) {
          output.relazioneContraenteBeneficiario = relazioneContraenteBeneficiario.map(key => ({
            key: key,
            value: key
          }))
        }
        const relazioneContraenteAssicurato: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'insuredRelationshipWithHolder', []);
        if (relazioneContraenteAssicurato) {
          output.relazioneContraenteAssicurato = relazioneContraenteAssicurato.map(key => ({
            key: key,
            value: key
          }))
        }
        const relazioneContraenteEsecutore: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'executorRelationshipWithHolder', []);
        if (relazioneContraenteEsecutore) {
          output.relazioneContraenteEsecutore = relazioneContraenteEsecutore.map(key => ({
            key: key,
            value: key
          }))
        }

        const tipoDelega: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'delegateRoles', []);
        if (tipoDelega) {
          output.tipoDelega = tipoDelega.map(key => ({
            key: key,
            value: key
          }))
        }
        const atecoList: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'atecoList', []);
        if (atecoList) {
          output.atecoList = atecoList.map(obj => ({
            key: obj.code,
            value: obj.description
          }))
        }
        const activityTypes: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'activityTypes', []);
        if (activityTypes) {
          output.activityTypes = activityTypes.map(obj => ({
            key: obj.description,
            value: obj.description
          }))
        }
        const currentBranchOffice: string = CommonUtils.checkAndGet(isvFormInfo, 'currentCab', null);
        if (currentBranchOffice) {
          output.currentBranchOffice = currentBranchOffice
        }
        let holderBeneficiaryRelationshipList: any[] = CommonUtils.checkAndGet(isvFormInfo, 'holderBeneficiaryRelationshipList', []);
        holderBeneficiaryRelationshipList = holderBeneficiaryRelationshipList.filter(obj => CommonUtils.checkAndGet(obj, 'TipoPersonaContraente', null) === contractorTypeDescription);
        if (holderBeneficiaryRelationshipList) {
          output.holderBeneficiaryRelationshipList = holderBeneficiaryRelationshipList.map(obj => ({
            key: CommonUtils.checkAndGet(obj, 'CodiceRelazione', null),
            value: CommonUtils.checkAndGet(obj, 'DescrizioneRelazione', null),
            additionalData: {
              beneficiaryType: CommonUtils.checkAndGet(obj, 'TipoPersonaBeneficiario', null)
            }
          }));
        }
        let insuredBeneficiaryRelationshipList: any[] = CommonUtils.checkAndGet(isvFormInfo, 'insuredBeneficiaryRelationshipList', []);
        insuredBeneficiaryRelationshipList = insuredBeneficiaryRelationshipList.filter(obj => CommonUtils.checkAndGet(obj, 'TipoPersonaContraente', null) === contractorTypeDescription);
        if (insuredBeneficiaryRelationshipList) {
          output.insuredBeneficiaryRelationshipList = insuredBeneficiaryRelationshipList.map(obj => ({
            key: CommonUtils.checkAndGet(obj, 'CodiceRelazione', null),
            value: CommonUtils.checkAndGet(obj, 'DescrizioneRelazione', null),
            additionalData: {
              beneficiaryType: CommonUtils.checkAndGet(obj, 'TipoPersonaBeneficiario', null)
            }
          }));
        }
        const beneficiaryDeathTipologies: any[] = CommonUtils.checkAndGet(isvFormInfo, 'beneficiaryDeathTipologies', []);
        if (beneficiaryDeathTipologies) {
          output.beneficiaryDeathTipologies = beneficiaryDeathTipologies.map(obj => ({
            key: CommonUtils.checkAndGet(obj, 'C_beneficiario', null),
            value: CommonUtils.checkAndGet(obj, 'Descrizione', null)
          }));
        }
        const beneficiaryLifeTipologies: any[] = CommonUtils.checkAndGet(isvFormInfo, 'beneficiaryLifeTipologies', []);
        if (beneficiaryLifeTipologies) {
          output.beneficiaryLifeTipologies = beneficiaryLifeTipologies.map(obj => ({
            key: CommonUtils.checkAndGet(obj, 'C_beneficiario', null),
            value: CommonUtils.checkAndGet(obj, 'Descrizione', null)
          }));
        }
        const activeFunds: any[] = CommonUtils.checkAndGet(isvFormInfo, 'activeFunds', []);
        if (activeFunds && canOverWriteFunds) {
          output.activeFunds = activeFunds.map(obj => ({
            fundCode: CommonUtils.checkAndGet(obj, 'code', null),
            description: CommonUtils.checkAndGet(obj, 'description', null),
            quoteNumber: CommonUtils.checkAndGet(obj, 'quoteNumber', null),
            quoteValue: CommonUtils.checkAndGet(obj, 'quoteValue', null),
            quoteValueUpdateDate: CommonUtils.checkAndGet(obj, 'quoteValueUpdatedAt', null),
            fundAmount: Number(CommonUtils.checkAndGet(obj, 'fundAmount', null))?.toLocaleString('it-IT', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }),
            percentage: CommonUtils.checkAndGet(obj, 'percentage', null),
            amount: "0"
          }));
        }
        const investmentFunds: any[] = CommonUtils.checkAndGet(isvFormInfo, 'investmentFunds', []);
        if (investmentFunds) {
          output.investmentFunds = investmentFunds.map(obj => ({
            fundCode: CommonUtils.checkAndGet(obj, 'code', null),
            description: CommonUtils.checkAndGet(obj, 'description', null),
            currentInvestedValue: Number(CommonUtils.checkAndGet(obj, 'fundAmount', 0))?.toLocaleString('it-IT', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }),
            percentage: CommonUtils.checkAndGet(obj, 'percentage', null),
            amount: "0"
          }));
        }
        const operationCost: string = CommonUtils.checkAndGet(isvFormInfo, 'operationCost', '0')?.toString();
        if (operationCost) {
            output.operationCost = operationCost
        }
        const operationEffectDate: string = CommonUtils.checkAndGet(isvFormInfo, 'operationEffectDate', '');
        if (operationEffectDate) {
            output.operationEffectDate = moment(operationEffectDate).format('DD/MM/YYYY');
        }
        const lines: any[] = CommonUtils.checkAndGet(isvFormInfo, 'lines', null);
        if (lines && lines.length > 0) {
            output.lines = lines.map(obj => ({
                code: CommonUtils.checkAndGet(obj, 'code', null),
                description: CommonUtils.checkAndGet(obj, 'description', null),
                selected: CommonUtils.checkAndGet(obj, 'selected', false),
                funds: obj.funds?.map(fund => ({
                    fundCode: fund.code,
                    fundAmount: fund.fundAmount,
                    description: fund.description,
                    percentage: fund.percentage
                })),
            }));
        }
        const rebalancedLine: any = CommonUtils.checkAndGet(isvFormInfo, 'rebalancedLine', null);
        if (rebalancedLine) {
            output.rebalancedLine = {
                code: rebalancedLine.code,
                description: rebalancedLine.description,
                funds: rebalancedLine.funds.map(fund=> ({
                    fundCode: fund.code,
                    description: fund.description,
                    fundAmount: fund.currentSplit.fundAmount,
                    percentage: fund.currentSplit.percentage,
                    futureFundAmount: fund.futureSplit.fundAmount,
                    futurePercentage: fund.futureSplit.percentage,
                    differenceAmount: fund.difference.fundAmount,
                    differencePercentage: fund.difference.percentage
                }))
            }
        }

        const emissionDates: any = CommonUtils.checkAndGet(isvFormInfo, 'emissionDate', null);
        if (emissionDates) {
            output.debitDate = CommonUtils.checkAndGet(emissionDates, 'DataAddebitoPremio', null);
            output.effectDate = CommonUtils.checkAndGet(emissionDates, 'DataDecorrenza', null);
        }
        const effectDate: string = CommonUtils.checkAndGet(isvFormInfo, 'effectDate', null);
        if (effectDate) {
            output.effectDate = effectDate
        }

        const describeExtraData = CommonUtils.checkAndGet(isvFormInfo, 'describeExtraData', null);
        if (describeExtraData) {
            output.describeExtraData = describeExtraData
        }

        const redemptionTypes: string[] = CommonUtils.checkAndGet(isvFormInfo, 'redemptionTypes', []);
        if (redemptionTypes) {
            output.redemptionTypes = redemptionTypes
        }
        output.countriesList = this.manageCountriesList(isvFormInfo);
        output.provincesList = this.manageProvincesList(isvFormInfo);
        return output;
    }

    static manageCountriesList(isvFormInfo: IIntesaFormFieldsResponse): IFormSelectOption[] {
        let output: IFormSelectOption[] = [];
        const countriesList: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'countriesList', []);
        if (countriesList) {
          output = countriesList.map(obj => ({
            key: obj.code,
            value: obj.description
          }))
        }
        return output;
    }

    static manageProvincesList(isvFormInfo: IIntesaFormFieldsResponse): IFormSelectOption[] {
        let output: IFormSelectOption[] = [];
        const provincesList: IGenericListIsv[] = CommonUtils.checkAndGet(isvFormInfo, 'provincesList', []);
        if (provincesList) {
          output = provincesList.map(obj => ({
            key: obj.code,
            value: obj.description
          }))
        }
        return output;
    }

    static initializeRegistryFormTemplate(policyHolderData: IPersonIntesa | ILegalPersonIntesa): any {
        if ('partitaIva' in policyHolderData) {
            return {
              denominazione: { value: policyHolderData.denominazione, disabled: true },
              partitaIva: { value: policyHolderData.partitaIva, disabled: true },
              dataNascita: { value: policyHolderData.partitaIva, disabled: false },
              presenzaListaEsterne: { value: policyHolderData.partitaIva, disabled: false },
            }
        } else {
            return {
              cognome: { value: policyHolderData.cognome, disabled: true },
              nome: { value: policyHolderData.nome, disabled: true },
              codiceFiscale: { value: policyHolderData.codiceFiscale, disabled: true },
              sesso: { value: policyHolderData.sesso, disabled: true },
              codiceSae: policyHolderData.sae,
              codiceAteco: policyHolderData.ateco,
              dataNascita: { value: policyHolderData.datiNascita?.dataNascita, disabled: true },
              statoNascita: { value: policyHolderData.datiNascita?.nazioneNascita, disabled: true },
              provinciaNascita: { value: policyHolderData.datiNascita?.provinciaNascita, disabled: true },
              comuneNascita: { value: policyHolderData.datiNascita?.comuneNascita, disabled: true },
              cittadinanza: null,
              secondaCittadinanza: null,
              presenzaListaEsterne: null,
              svolgimentoRappContinuativo: null,
              svolgimentoOperazione: null,
              comportamentoCliente: null
          }
        }
    }

    static initializeLegalGuardianRegistryFormTemplate(policyHolderData: IPersonIntesa): any {
        return {
            cognome: { value: policyHolderData.cognome, disabled: true },
            nome: { value: policyHolderData.nome, disabled: true },
            sesso: { value: policyHolderData.sesso, disabled: true },
            codiceFiscale: { value: policyHolderData.codiceFiscale, disabled: true },
            codiceSae: { value: policyHolderData.sae, disabled: true },
            codiceAteco: { value: policyHolderData.ateco, disabled: true },
            dataNascita: { value: policyHolderData.datiNascita?.dataNascita, disabled: true },
            statoNascita: { value: policyHolderData.datiNascita?.nazioneNascita, disabled: true },
            provinciaNascita: { value: policyHolderData.datiNascita?.provinciaNascita, disabled: true },
            comuneNascita: { value: policyHolderData.datiNascita?.comuneNascita, disabled: true },
            cittadinanza: { value: null, disabled: false },
            secondaCittadinanza: { value: null, disabled: false },
            isPEP: { value: null, disabled: false },
            relazioneContraenteEsecutore: { value: null, disabled: false },
            comportamentoCliente: { value: null, disabled: false },
            tipoDelega: { value: null, disabled: false }
        }
    }

    static initializeEffectiveOwnerRegistryFormTemplate(subjectData: any): any {
        return {
            cognome: { value: subjectData.lastName, disabled: true },
            nome: { value: subjectData.firstName, disabled: true },
            sesso: { value: subjectData.gender, disabled: true },
            codiceFiscale: { value: subjectData.fiscalCode, disabled: true },
            dataNascita: { value: subjectData.birthAddress?.DataNascita, disabled: true },
            statoNascita: { value: subjectData.birthAddress?.NazioneNascita, disabled: true },
            provinciaNascita: { value: subjectData.birthAddress?.ProvinciaNascita, disabled: true },
            comuneNascita: { value: subjectData.birthAddress?.ComuneNascita, disabled: true },
            cittadinanza: { value: null, disabled: false },
            secondaCittadinanza: { value: null, disabled: false },
            isPEP: { value: null, disabled: false },
            comportamentoCliente: { value: null, disabled: false },
        }
    }

    static initializeRegistryFormTemplateForRegistryAdjustment(policyHolderData: IPersonIntesa): any {
        return {
            cognome: { value: policyHolderData.cognome, disabled: false },
            nome: { value: policyHolderData.nome, disabled: false },
            codiceFiscale: { value: policyHolderData.codiceFiscale, disabled: true },
            sesso: { value: policyHolderData.sesso, disabled: true },
            codiceSae: { value: policyHolderData.sae, disabled: true },
            codiceAteco: { value: policyHolderData.ateco, disabled: true },
            dataNascita: { value: policyHolderData.datiNascita?.dataNascita, disabled: true },
            statoNascita: { value: policyHolderData.datiNascita?.nazioneNascita, disabled: true },
            provinciaNascita: { value: policyHolderData.datiNascita?.provinciaNascita, disabled: true },
            comuneNascita: { value: policyHolderData.datiNascita?.comuneNascita, disabled: true },
        }
    }

    static initializeRegistryFormTemplateForInsured(insured: IPolicyDetailSubject): any {
      return {
          cognome: { value: insured.surname, disabled: true },
          nome: { value: insured.name, disabled: true },
          codiceFiscale: { value: insured.taxOrVatCode, disabled: true },
          dataNascita: { value: insured.birthDate, disabled: true },
          dataDecesso: null
      }
    }

    static initializeNewContractorRegistryFormTemplate(
      newContractorData: any,
      type: string,
      isEsecutoreConto?: boolean
    ): any {
      const isLegalPerson = type !== ESpecificBeneficiaryType.PERSONA_FISICA;
      if (newContractorData) {
        if (isLegalPerson) {
          return { // TODO
            ragioneSociale: { value: newContractorData.companyName, disabled: true },
            partitaIva: { value: newContractorData.vatCode, disabled: true },
            dataNascita: { value: null, disabled: false },
            holderRelationship: { value: null, disabled: false }
          }
        } else {
          return {
            cognome: { value: newContractorData.lastName, disabled: true },
            nome: { value: newContractorData.firstName, disabled: true },
            codiceFiscale: { value: newContractorData.fiscalCode, disabled: true },
            sesso: { value: newContractorData.gender, disabled: true },
            codiceSae: newContractorData.SAECode,
            codiceAteco: newContractorData.atecoCode,
            dataNascita: { value: newContractorData.birthAddress?.DataNascita, disabled: true },
            statoNascita: { value: newContractorData.birthAddress?.NazioneNascita, disabled: true },
            provinciaNascita: { value: newContractorData.birthAddress?.ProvinciaNascita, disabled: true },
            comuneNascita: { value: newContractorData.birthAddress?.ComuneNascita, disabled: true },
            holderRelationship: { value: null, disabled: false },
            cittadinanza: { value: null, disabled: false },
            comportamentoCliente: { value: null, disabled: false },
            activityType: { value: null, disabled: false },
            codiceTae: { value: null, disabled: true },
          }
        }
      } else {
        if (isLegalPerson) {
          return {
            ragioneSociale: { value: null, disabled: false },
            partitaIva: { value: null, disabled: false },
            dataNascita: { value: null, disabled: false },
            holderRelationship: { value: null, disabled: false }
          }
        } else {
          return {
            cognome: { value: null, disabled: false },
            nome: { value: null, disabled: false },
            codiceFiscale: { value: null, disabled: false },
            sesso: { value: null, disabled: false },
            codiceSae: { value: null, disabled: false },
            codiceAteco: { value: null, disabled: false },
            dataNascita: { value: null, disabled: false },
            statoNascita: { value: null, disabled: false },
            provinciaNascita: { value: null, disabled: false },
            comuneNascita: { value: null, disabled: false },
            ...( !isEsecutoreConto ? {holderRelationship: { value: null, disabled: false }} : {}),
            cittadinanza: { value: null, disabled: false },
            comportamentoCliente: { value: null, disabled: false },
            secondaCittadinanza: { value: null, disabled: false },
            tipoDelega: { value: null, disabled: false },
            isPEP: { value: null, disabled: false },
            relazioneContraenteEsecutore: { value: null, disabled: false }
          }
        }
      }
    }

    static initializeNewContractorLegalGuardianRegistryFormTemplate(policyHolderData: any): any {
        return {
            cognome: { value: policyHolderData.lastName, disabled: true },
            nome: { value: policyHolderData.firstName, disabled: true },
            codiceFiscale: { value: policyHolderData.fiscalCode, disabled: true },
            sesso: { value: policyHolderData.gender, disabled: true },
            codiceSae: { value: policyHolderData.SAECode, disabled: true },
            codiceAteco: { value: policyHolderData.atecoCode, disabled: true },
            dataNascita: { value: policyHolderData.birthAddress?.DataNascita, disabled: true },
            statoNascita: { value: policyHolderData.birthAddress?.NazioneNascita, disabled: true },
            provinciaNascita: { value: policyHolderData.birthAddress?.ProvinciaNascita, disabled: true },
            comuneNascita: { value: policyHolderData.birthAddress?.ComuneNascita, disabled: true },
            cittadinanza: { value: null, disabled: false },
            secondaCittadinanza: { value: null, disabled: false },
            isPEP: { value: null, disabled: false },
            relazioneContraenteEsecutore: { value: null, disabled: false },
            comportamentoCliente: { value: null, disabled: false },
            tipoDelega: { value: null, disabled: false }
        }
    }

    static initializeBusinessFormTemplate(policyHolderData: IPersonIntesa | ILegalPersonIntesa): any {
      const isLegalPerson = 'partitaIva' in policyHolderData;
      if (isLegalPerson) {
        return {
          classeBeneficiariSuCuiSiRivolgonoLeAttivita: { value: null, disabled: false },
          codiceAteco: { value: null, disabled: false },
          codiceSae: { value: null, disabled: false },
          tipoSocietaImpresa: { value: null, disabled: false },
          fasciaReddito: null
        }
      } else {
        const ateco = policyHolderData.ateco === "NESSUN CODICE ATECO" ? null : policyHolderData.ateco;
        return {
          codiceSae: { value: policyHolderData.sae, disabled: false },
          codiceTae: { value: null, disabled: true },
          codiceAteco: { value: ateco, disabled: false },
          activityType: { value: null, disabled: false },
          fasciaReddito: null
        };
      }
    }

    static initializeNewContractorBusinessFormTemplate(
      newContractorData: any,
      type: string
    ): any {
      const isLegalPerson = type !== ESpecificBeneficiaryType.PERSONA_FISICA;
      let template = null;
      if (isLegalPerson) {
        template = {
            classeBeneficiariSuCuiSiRivolgonoLeAttivita: { value: null, disabled: false },
            codiceAteco: { value: null, disabled: false },
            codiceSae: { value: null, disabled: false },
            tipoSocietaImpresa: { value: null, disabled: false },
            fasciaReddito: null
        }
      } else {
        template = {
            codiceAteco: { value: null, disabled: false },
            codiceSae: { value: isLegalPerson ? null : newContractorData?.SAECode, disabled: false },
            codiceTae: { value: null, disabled: true },
            activityType: { value: null, disabled: false },
        };
      }
      return template;
    }

    static initializeNewContractorDocumentFormTemplate(
      newContractorData: any
    ): any {
      if (newContractorData) {
        const documentData = CommonUtils.checkAndGet(newContractorData, 'document', null);
        return {
          tipoDocumento: documentData?.TipoDocumento,
          dataRilascio: documentData?.DataRilascio,
          numeroDocumento: documentData?.NumeroDocumento,
          comuneRilascio: documentData?.LuogoRilascio,
          enteRilascio: documentData?.EnteRilascio
        }
      } else {
        return {
          tipoDocumento: null,
          dataRilascio: null,
          numeroDocumento: null,
          comuneRilascio: null,
          enteRilascio: null
        }
      }
    }

    // endregion


    static retrieveOperationTemplate(
        operationId: string,
        policyId: string,
        agencyCode: string,
        counterValue: string,
        policyDetail: IPolicyDetail
    ): any {
        let template = null;
        const productCode = CommonUtils.checkAndGet(policyDetail, 'summary.productCode', null);
        switch (operationId) {
            case '_RISTO':
                template = gianos_operation_data_form_template;
                template.policyNumber = { value: policyId, disabled: true };
                template.agencyCode = { value: agencyCode, disabled: true };
                template.productCode = { value: productCode, disabled: true };
                template.redeemType = { value: 'Riscatto Totale', disabled: true };
                template.operationAmount = { value: counterValue, disabled: true };
                template.operationPurpose = { value: null, disabled: false };
                break;
            case '_RISPA':
                template = gianos_operation_data_form_template;
                template.policyNumber = { value: policyId, disabled: true };
                template.agencyCode = { value: agencyCode, disabled: true };
                template.productCode = { value: productCode, disabled: true };
                template.redeemType = { value: 'Riscatto Parziale', disabled: true };
                template.operationAmount = { value: counterValue, disabled: true };
                template.operationPurpose = { value: null, disabled: false };
                break;
            case '10':
                template = gianos_operation_data_form_template;
                template.policyNumber = { value: policyId, disabled: true };
                template.agencyCode = { value: agencyCode, disabled: true };
                template.productCode = { value: productCode, disabled: true };
                template.liquidationMaturity = { value: 'Liquidazione', disabled: true };
                template.operationAmount = { value: null, disabled: true };
                break;
            case '_VCONT':
                template = gianos_operation_data_form_template;
                template.policyNumber = { value: policyId, disabled: true };
                template.agencyCode = { value: agencyCode, disabled: true };
                template.productCode = { value: productCode, disabled: true };
                break;
            case '_VAGG':
                template = gianos_operation_data_form_template;
                template.policyNumber = { value: policyId, disabled: true };
                template.agencyCode = { value: agencyCode, disabled: true };
                template.productCode = { value: productCode, disabled: true };
                template.additionalPaymentType = { value: 'Versamento Aggiuntivo' , disabled: true };
                template.operationAmount = { value: null, disabled: true };
                break;
            default:
                break;
        }
        return template;
    }

    static retrieveOperationValidators(operationId: string): any {
        let template = null;
        switch (operationId) {
          case '_RISTO':
          case '_RISPA':
            template = risto_operation_data_form_validators;
            break;
          case '_VCONT':
            template = vcont_operation_data_form_validators;
            break;
          case '10':
            template = liquidation_maturity_operation_data_form_validators;
            break;
          case '_VAGG':
            template = vagg_operation_data_form_validators;
            break;
          default:
            break;
        }
        return template;
    }

    // region payload per CONFERMA OPERAZIONE

    static getPayloadForRiscattoTotale(
      policyNumber: string,
      contractorRegistryRawValue: any,
      documentRawValue: any,
      businessRawValue: any,
      residenceRawValue: any,
      addressRawValue: any,
      insuredForm: any,
      operationDataRawValue: any,
      operatorDataRawValue: any,
      beneficiaryRawValue: any,
      effectiveOwnersList: IPersonIntestaFormGroups[],
      legalGuardianRegistryRawValue: any,
      legalGuardianResidenceRawValue: any,
      legalGuardianIdentificationDocumentRawValue: any,
      ndgTutore: string,
      funds: IPolicyAsset[],
      counterValue: string,
      iban: string,
      ibanList: IIbanObject[],
      agreementPurpose: any,
      fiscalRegime?: string,
      describeExtraData?: any
    ): IIsvRiscattoTotaleRequest {
      const contraente: IGianosPolicyHolder = this.getGianosPolicyHolderData(
        contractorRegistryRawValue,
        documentRawValue,
        businessRawValue,
        residenceRawValue,
        addressRawValue
      );
      const assicurato: IGianosPolicyInsured = !CommonUtils.isVoidObj(insuredForm)
        ? this.getGianosInsuredData(
          insuredForm
        )
        : null;
      const polizzaOperazione: IGianosOperationInfo = this.getGianosOperationData(
        operationDataRawValue,
        counterValue,
        agreementPurpose
      );
      const operatoreContraente: IGianosDatiOperatore = this.getGianosOperatorData(
        operatorDataRawValue,
        !CommonUtils.isVoidObj(legalGuardianRegistryRawValue) ? legalGuardianRegistryRawValue : contractorRegistryRawValue
      );
      const designazioneBeneficiario: IGianosDesignazioneBeneficiari[] = !CommonUtils.isVoidObj(beneficiaryRawValue)
        ? this.getGianosBeneficiary(
          beneficiaryRawValue
        )
        : null;
      const titolareEffettivi: IGianosTitolareEffettivo[] = this.getGianosTitolariEffettivi(
        effectiveOwnersList
      );
      const esecutoreConto: IGianosEsecutoreConto = !CommonUtils.isVoidObj(legalGuardianRegistryRawValue)
        ? this.getGianosRappresentanteLegale(
          legalGuardianRegistryRawValue,
          legalGuardianResidenceRawValue,
          legalGuardianIdentificationDocumentRawValue
        )
        : null;
      const paymentMode: IGianosPaymentMode = this.getGianosPaymentMode(
        operationDataRawValue,
        iban,
        ibanList,
        counterValue
      );
      const codiceLineaCompagnia: string[] = [];
      const controvaloreLineaCompagnia: string[] = [];
      if (funds && funds.length > 0) {
        funds.forEach(fund => {
          if (fund && fund.fundCode) {
            codiceLineaCompagnia.push(CommonUtils.checkAndGet(fund, 'fundCode', null));
            controvaloreLineaCompagnia.push(CommonUtils.checkAndGet(fund, 'fundAmount', null));
          }
        });
      }
      const operationPurpose = CommonUtils.checkAndGet(operationDataRawValue, 'operationPurpose', null);
      let body: IIsvRiscattoTotaleRequest = {
        policyNumber: policyNumber,
        contraente: contraente,
        assicurato: assicurato,
        polizzaOperazione: polizzaOperazione,
        operatoreContraente: operatoreContraente,
        paymentMode: paymentMode,
        designazioneBeneficiario: designazioneBeneficiario,
        titolareEffettivi: titolareEffettivi,
        ndgTutoreODelegato: ndgTutore,
        codiceLineaCompagnia: codiceLineaCompagnia,
        controvaloreLineaCompagnia: controvaloreLineaCompagnia,
        esecutoreConto: esecutoreConto,
        consultancyAmount: Number(counterValue)?.toFixed(2).toString().replace(/\./g, ','),
        taxRegime: fiscalRegime,
        operationPurpose: operationPurpose,
        describeExtraData: describeExtraData
      };
      return body;
    }

    static getPayloadForLiquidazioneScadenza(
      policyNumber: string,
      contractorRegistryRawValue: any,
      documentRawValue: any,
      businessRawValue: any,
      residenceRawValue: any,
      addressRawValue: any,
      insuredForm: any,
      operationDataRawValue: any,
      operatorDataRawValue: any,
      beneficiaryRawValue: any,
      effectiveOwnersList: IPersonIntestaFormGroups[],
      legalGuardianRegistryRawValue: any,
      legalGuardianResidenceRawValue: any,
      legalGuardianIdentificationDocumentRawValue: any,
      counterValue: string,
      iban: string,
      ibanList: IIbanObject[],
      agreementPurpose: any,
      effectDate: string
    ): IIsvLiquidazioneScadenzaRequest {
      const contraente: IGianosPolicyHolder = this.getGianosPolicyHolderData(
        contractorRegistryRawValue,
        documentRawValue,
        businessRawValue,
        residenceRawValue,
        addressRawValue
      );
      const assicurato: IGianosPolicyInsured = !CommonUtils.isVoidObj(insuredForm)
        ? this.getGianosInsuredData(
          insuredForm
        )
        : null;
      const polizzaOperazione: IGianosOperationInfo = this.getGianosOperationData(
        operationDataRawValue,
        counterValue,
        agreementPurpose
      );
      const operatoreContraente: IGianosDatiOperatore = this.getGianosOperatorData(
        operatorDataRawValue,
        !CommonUtils.isVoidObj(legalGuardianRegistryRawValue) ? legalGuardianRegistryRawValue : contractorRegistryRawValue
      );
      const designazioneBeneficiario: IGianosDesignazioneBeneficiari[] = !CommonUtils.isVoidObj(beneficiaryRawValue)
        ? this.getGianosBeneficiary(
          beneficiaryRawValue
        )
        : null;
      const titolareEffettivi: IGianosTitolareEffettivo[] = this.getGianosTitolariEffettivi(
        effectiveOwnersList
      );
      const esecutoreConto: IGianosEsecutoreConto = !CommonUtils.isVoidObj(legalGuardianRegistryRawValue)
        ? this.getGianosRappresentanteLegale(
          legalGuardianRegistryRawValue,
          legalGuardianResidenceRawValue,
          legalGuardianIdentificationDocumentRawValue
        )
        : null;
      const paymentMode: IGianosPaymentMode = this.getGianosPaymentMode(
        operationDataRawValue,
        iban,
        ibanList,
        counterValue
      );
      let body: IIsvLiquidazioneScadenzaRequest = {
        policyNumber: policyNumber,
        contraente: contraente,
        assicurato: assicurato,
        polizzaOperazione: polizzaOperazione,
        operatoreContraente: operatoreContraente,
        paymentMode: paymentMode,
        designazioneBeneficiario: designazioneBeneficiario,
        titolareEffettivi: titolareEffettivi,
        esecutoreConto: esecutoreConto,
        effectDate: effectDate
      };
      return body;
    }

    static getPayloadForRiscattoParzialeTariffazione(
      policyNumber: string,
      operationCode: string,
      firstStepFormRawValue: any,
      activeFunds: IPolicyAsset[],
      selectedRedemptionType: string
    ) {
      let importoOperazione: string = CommonUtils.checkAndGet(firstStepFormRawValue, 'amount', null);
      importoOperazione = importoOperazione?.toString().replace(/\./g, '');
      importoOperazione = importoOperazione?.replace(/\,/g, '.');
      const fundsList = activeFunds?.length > 0
        ? this.getGianosFundsList(activeFunds):
        null;

      let body = {
        policyNumber: policyNumber,
        operationCode: operationCode,
        amount: importoOperazione,
        fundsList: fundsList,
        redemptionType: selectedRedemptionType,
        isFinalized: 'NO'
      };
      return body;
    }

    static getPayloadForRiscattoParziale(
      policyNumber: string,
      firstStepFormRawValue: any,
      contractorRegistryRawValue: any,
      documentRawValue: any,
      businessRawValue: any,
      residenceRawValue: any,
      addressRawValue: any,
      insuredForm: any,
      operationDataRawValue: any,
      operatorDataRawValue: any,
      beneficiaryRawValue: any,
      effectiveOwnersList: IPersonIntestaFormGroups[],
      legalGuardianRegistryRawValue: any,
      legalGuardianResidenceRawValue: any,
      legalGuardianIdentificationDocumentRawValue: any,
      iban: string,
      ibanList: IIbanObject[],
      activeFunds: IPolicyAsset[],
      ndgTutoreODelegato: string,
      agreementPurpose: any,
      selectedRedemptionType: string,
      describeExtraData?: any
    ): IIsvRiscattoParzialeRequest {
      const contraente: IGianosPolicyHolder = this.getGianosPolicyHolderData(
        contractorRegistryRawValue,
        documentRawValue,
        businessRawValue,
        residenceRawValue,
        addressRawValue
      );
      const assicurato: IGianosPolicyInsured = !CommonUtils.isVoidObj(insuredForm)
        ? this.getGianosInsuredData(
          insuredForm
        )
        : null;
      let importoOperazione: string = CommonUtils.checkAndGet(firstStepFormRawValue, 'amount', null);
      importoOperazione = importoOperazione?.toString().replace(/\./g, '');
      importoOperazione = importoOperazione?.replace(/\,/g, '.');
      const polizzaOperazione: IGianosOperationInfo = this.getGianosOperationData(
        operationDataRawValue,
        importoOperazione,
        agreementPurpose
      );
      const operatoreContraente: IGianosDatiOperatore = this.getGianosOperatorData(
        operatorDataRawValue,
        !CommonUtils.isVoidObj(legalGuardianRegistryRawValue) ? legalGuardianRegistryRawValue : contractorRegistryRawValue
      );
      const designazioneBeneficiario: IGianosDesignazioneBeneficiari[] = !CommonUtils.isVoidObj(beneficiaryRawValue)
        ? this.getGianosBeneficiary(
          beneficiaryRawValue
        )
        : null;
      const titolareEffettivi: IGianosTitolareEffettivo[] = this.getGianosTitolariEffettivi(
        effectiveOwnersList
      );
      const esecutoreConto: IGianosEsecutoreConto = !CommonUtils.isVoidObj(legalGuardianRegistryRawValue)
        ? this.getGianosRappresentanteLegale(
          legalGuardianRegistryRawValue,
          legalGuardianResidenceRawValue,
          legalGuardianIdentificationDocumentRawValue
        )
        : null;
      const paymentMode: IGianosPaymentMode = this.getGianosPaymentMode(
        operationDataRawValue,
        iban,
        ibanList,
        importoOperazione
      );
      const fundsList = activeFunds?.length > 0
        ? this.getGianosFundsList(activeFunds):
        null;
      const codiceLineaCompagnia: string[] = [];
      const controvaloreLineaCompagnia: string[] = [];
      if (activeFunds && activeFunds.length > 0) {
        activeFunds.forEach(fund => {
          if (fund && fund.fundCode) {
            codiceLineaCompagnia.push(CommonUtils.checkAndGet(fund, 'fundCode', null));
            let fundAmount: string = CommonUtils.checkAndGet(fund, 'amount', null);
            fundAmount = fundAmount?.toString().replace(/\./g, '');
            controvaloreLineaCompagnia.push(fundAmount);
          }
        });
      }
      let consultancyAmount: string = CommonUtils.checkAndGet(firstStepFormRawValue, 'amount', null);
      consultancyAmount = consultancyAmount?.toString().replace(/\./g, '');

      const fiscalRegime = CommonUtils.checkAndGet(firstStepFormRawValue, 'fiscalRegime', null);
      const operationPurpose = CommonUtils.checkAndGet(operationDataRawValue, 'operationPurpose', null);

      let body: IIsvRiscattoParzialeRequest = {
        policyNumber: policyNumber,
        contraente: contraente,
        assicurato: assicurato,
        polizzaOperazione: polizzaOperazione,
        operatoreContraente: operatoreContraente,
        paymentMode: paymentMode,
        designazioneBeneficiario: designazioneBeneficiario,
        titolareEffettivi: titolareEffettivi,
        esecutoreConto: esecutoreConto,
        fundsList: fundsList,
        isFinalized: 'NO',
        consultancyAmount: consultancyAmount,
        codiceLineaCompagnia: codiceLineaCompagnia,
        controvaloreLineaCompagnia: controvaloreLineaCompagnia,
        ndgTutoreODelegato: ndgTutoreODelegato,
        redemptionType: selectedRedemptionType,
        taxRegime: fiscalRegime,
        operationPurpose,
        describeExtraData
      };
      return body;
    }

    static getPayloadForAdditionalPaymentPrev(policyNumber: string, rawValue: any, ibanList: IIbanObject[]) {
      const ibanValue: string = rawValue.iban;
      const ibanObj: IIbanObject = ibanList.find(obj => obj?.numeroRapporto === ibanValue.substring(10));

      const body: IAdditionalPaymentRequest = {
        policyNumber: policyNumber,
        iban: CommonUtils.formatIBANString(ibanObj),
        codeRapporto: ibanValue,
        grossPremium: CommonUtils.checkAndGet(rawValue, 'amount', null),
        debitDate: CommonUtils.checkAndGet(rawValue, 'debitDate', null)
      }

      return body
    }

    static getPayloadForSpostamentoIscritto(
      policyNumber: string,
      employers: any[]
    ) {
      const body: ISpostamentoIscrittoRequest = {
        policyNumber: policyNumber,
        employers: employers
      }

      return body
    }

    static getPayloadForAdditionalPaymentTariffazione(
      policyNumber: string,
      operationCode: string,
      firstStepFormRawValue: any,
      operationDataRawValue: any,
      iban: string,
      ibanList: IIbanObject[],
      activeFunds: IPolicyAsset[],
      policyValue: string
    ) {
      let importoOperazione: string = CommonUtils.checkAndGet(firstStepFormRawValue, 'amount', null);
      let lineCode: string = CommonUtils.checkAndGet(firstStepFormRawValue, 'additionalPaymentLine', null);
      importoOperazione = importoOperazione?.toString().replace(/\./g, '');
      importoOperazione = importoOperazione?.replace(/\,/g, '.');
      const paymentMode: IGianosPaymentMode = this.getGianosPaymentMode(
        operationDataRawValue,
        iban,
        ibanList,
        importoOperazione
      );
      const fundsList = activeFunds?.length > 0
        ? this.getGianosFundsList(activeFunds):
        null;
      const depositType: string = CommonUtils.isVoidObj(fundsList)
        ? 'NonDefinito'
        : firstStepFormRawValue?.type ? 'Selettivo' : 'Proporzionale';
      let body = {
        policyNumber: policyNumber,
        operationCode: operationCode,
        policyValue: policyValue,
        paymentMode: paymentMode,
        fundsList: fundsList,
        depositType: depositType,
        lineCode: lineCode
      };
      return body;
    }

    static getPayloadForAdditionalPayment(
      policyNumber: string,
      firstStepFormRawValue: any,
      contractorRegistryRawValue: any,
      documentRawValue: any,
      businessRawValue: any,
      residenceRawValue: any,
      addressRawValue: any,
      insuredForm: any,
      operationDataRawValue: any,
      operatorDataRawValue: any,
      beneficiaryRawValue: any,
      effectiveOwnersList: IPersonIntestaFormGroups[],
      legalGuardianRegistryRawValue: any,
      legalGuardianResidenceRawValue: any,
      legalGuardianIdentificationDocumentRawValue: any,
      iban: string,
      ibanList: IIbanObject[],
      activeFunds: IPolicyAsset[],
      ndgTutoreODelegato: string,
      policyValue: string,
      agreementPurpose: any,
      effectDate: string
    ): IAdditionalPaymentRequestIsv {
      const contraente: IGianosPolicyHolder = this.getGianosPolicyHolderData(
        contractorRegistryRawValue,
        documentRawValue,
        businessRawValue,
        residenceRawValue,
        addressRawValue
      );
      const assicurato: IGianosPolicyInsured = !CommonUtils.isVoidObj(insuredForm)
        ? this.getGianosInsuredData(
          insuredForm
        )
        : null;
      let importoOperazione: string = CommonUtils.checkAndGet(firstStepFormRawValue, 'amount', null);
      let lineCode: string = CommonUtils.checkAndGet(firstStepFormRawValue, 'additionalPaymentLine', null);
      importoOperazione = importoOperazione?.toString().replace(/\./g, '');
      importoOperazione = importoOperazione?.replace(/\,/g, '.');
      const polizzaOperazione: IGianosOperationInfo = this.getGianosOperationData(
        operationDataRawValue,
        importoOperazione,
        agreementPurpose
      );
      const operatoreContraente: IGianosDatiOperatore = this.getGianosOperatorData(
        operatorDataRawValue,
        !CommonUtils.isVoidObj(legalGuardianRegistryRawValue) ? legalGuardianRegistryRawValue : contractorRegistryRawValue
      );
      const designazioneBeneficiario: IGianosDesignazioneBeneficiari[] = !CommonUtils.isVoidObj(beneficiaryRawValue)
        ? this.getGianosBeneficiary(
          beneficiaryRawValue
        )
        : null;
      const titolareEffettivi: IGianosTitolareEffettivo[] = this.getGianosTitolariEffettivi(
        effectiveOwnersList
      );
      const esecutoreConto: IGianosEsecutoreConto = !CommonUtils.isVoidObj(legalGuardianRegistryRawValue)
        ? this.getGianosRappresentanteLegale(
          legalGuardianRegistryRawValue,
          legalGuardianResidenceRawValue,
          legalGuardianIdentificationDocumentRawValue
        )
        : null;
      const paymentMode: IGianosPaymentMode = this.getGianosPaymentMode(
        operationDataRawValue,
        iban,
        ibanList,
        importoOperazione
      );
      const fundsList = activeFunds?.length > 0
        ? this.getGianosFundsList(activeFunds):
        null;
      const codiceLineaCompagnia: string[] = [];
      const controvaloreLineaCompagnia: string[] = [];
      if (fundsList && fundsList.length > 0) {
        fundsList.forEach(fund => {
          if (fund && fund.fundCode) {
            codiceLineaCompagnia.push(CommonUtils.checkAndGet(fund, 'fundCode', null));
            controvaloreLineaCompagnia.push(CommonUtils.checkAndGet(fund, 'amount', null));
          }
        });
      }
      let consultancyAmount: string = CommonUtils.checkAndGet(firstStepFormRawValue, 'amount', null);
      consultancyAmount = consultancyAmount?.toString().replace(/\./g, '');
      const depositType: string = CommonUtils.isVoidObj(fundsList)
        ? 'NonDefinito'
        : firstStepFormRawValue?.type ? 'Selettivo' : 'Proporzionale';
      let body: IAdditionalPaymentRequestIsv = {
        policyNumber: policyNumber,
        contraente: contraente,
        assicurato: assicurato,
        polizzaOperazione: polizzaOperazione,
        operatoreContraente: operatoreContraente,
        paymentMode: paymentMode,
        designazioneBeneficiario: designazioneBeneficiario,
        titolareEffettivi: titolareEffettivi,
        esecutoreConto: esecutoreConto,
        fundsList: fundsList,
        consultancyAmount: consultancyAmount,
        codiceLineaCompagnia: codiceLineaCompagnia,
        controvaloreLineaCompagnia: controvaloreLineaCompagnia,
        ndgTutoreODelegato: ndgTutoreODelegato,
        policyValue: policyValue,
        depositType: depositType,
        lineCode: lineCode,
        effectDate: effectDate
      };
      return body;
    }

    static getPayloadForCessioneContraenza(
      policyNumber: string,
      firstStepFormRawValue: any,
      contractorRegistryRawValue: any,
      documentRawValue: any,
      businessRawValue: any,
      residenceRawValue: any,
      addressRawValue: any,
      insuredForm: any,
      operationDataRawValue: any,
      operatorDataRawValue: any,
      beneficiaryRawValue: any,
      effectiveOwnersList: IPersonIntestaFormGroups[],
      legalGuardianRegistryRawValue: any,
      legalGuardianResidenceRawValue: any,
      legalGuardianIdentificationDocumentRawValue: any,
      newContractorProperVerificationRawValue: any,
      newContractorConsentsRawValue: any,
      additionalFormRawValue: any,
      legalGuardianProperVerificationRawValue: any,
      holdersRelationshipList: any[],
      oldContractorType: string,
      chargeTypes: any[],
      agreementPurpose: any
    ): IIsvCessioneContraenzaRequest {
      let contraente: IGianosPolicyHolder = this.getGianosPolicyHolderData(
        contractorRegistryRawValue,
        documentRawValue,
        businessRawValue,
        residenceRawValue,
        addressRawValue
      );
      const isPF = contraente && !contraente.partitaIVA;

      const assicurato: IGianosPolicyInsured = !CommonUtils.isVoidObj(insuredForm)
        ? this.getGianosInsuredData(
          insuredForm
        )
        : null;
      const polizzaOperazione: IGianosOperationInfo = this.getGianosOperationData(
        operationDataRawValue,
        null,
        agreementPurpose
      );
      const operatoreContraente: IGianosDatiOperatore = this.getGianosOperatorData(
        operatorDataRawValue,
        !CommonUtils.isVoidObj(legalGuardianRegistryRawValue) ? legalGuardianRegistryRawValue : contractorRegistryRawValue
      );
      const designazioneBeneficiario: IGianosDesignazioneBeneficiari[] = !CommonUtils.isVoidObj(beneficiaryRawValue)
        ? this.getGianosBeneficiary(
          beneficiaryRawValue
        )
        : null;
      const titolareEffettivi: IGianosTitolareEffettivo[] = this.getGianosTitolariEffettivi(
        effectiveOwnersList
      );
      const esecutoreConto: IGianosEsecutoreConto = !CommonUtils.isVoidObj(legalGuardianRegistryRawValue)
        ? this.getGianosRappresentanteLegale(
          legalGuardianRegistryRawValue,
          legalGuardianResidenceRawValue,
          legalGuardianIdentificationDocumentRawValue
        )
        : null;
      const holderAdequateVerification: IGianosAdequateVerification = this.getContractorGianosAdequateVerification(
        newContractorProperVerificationRawValue,
        CommonUtils.checkAndGet(contractorRegistryRawValue, 'fiscalCode', null),
        chargeTypes
      );
      const legalPersonAdequateVerification: IGianosAdequateVerification = this.getGianosAdequateVerification(
        legalGuardianProperVerificationRawValue,
        CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'fiscalCode', null)
      );
      const tutorsAdequateVerification: IGianosAdequateVerification[] = this.getTutorsGianosAdequateVerification(
        effectiveOwnersList
      );
      const privacy: IGianosPrivacy = this.getGianosPrivacy(
        newContractorConsentsRawValue,
        CommonUtils.checkAndGet(firstStepFormRawValue, 'fiscalCode', null)
      );
      const anagraphicType: string = CommonUtils.checkAndGet(firstStepFormRawValue, 'type', null) === ESpecificBeneficiaryType.PERSONA_FISICA ? 'Contraente' : 'Azienda';
      const personType: string = CommonUtils.checkAndGet(firstStepFormRawValue, 'type', null) === ESpecificBeneficiaryType.PERSONA_FISICA ? 'Fisica' : 'Giuridica';
      const isSubjectAble: boolean = additionalFormRawValue?.isContractorCapable === 'SI' ? true : false;
      const tipoRelazione: string = CommonUtils.checkAndGet(contractorRegistryRawValue, 'holderRelationship', null);
      const holdersRelationship: IGianosHoldersRelationship = {
        TipoRelazione: tipoRelazione,
        Descrizione: holdersRelationshipList?.find(item => item.key == tipoRelazione)?.value,
        TipoContraente: oldContractorType,
        TipoContraenteNew: CommonUtils.checkAndGet(firstStepFormRawValue, 'type', null) === ESpecificBeneficiaryType.PERSONA_FISICA ? 'F' : 'G',
      }
      let body: IIsvCessioneContraenzaRequest = {
        policyNumber: policyNumber,
        contraente: isPF ? { ...contraente, fasciaRedditoFatturatoContraente: holderAdequateVerification.incomeLevel } : contraente,
        assicurato: assicurato,
        polizzaOperazione: polizzaOperazione,
        operatoreContraente: operatoreContraente,
        designazioneBeneficiario: designazioneBeneficiario,
        titolareEffettivi: titolareEffettivi,
        esecutoreConto: esecutoreConto,
        holderAdequateVerification: holderAdequateVerification,
        legalPersonAdequateVerification: legalPersonAdequateVerification,
        tutorAdequateVerification: tutorsAdequateVerification,
        privacy: privacy,
        anagraphicType: anagraphicType,
        personType: personType,
        isSubjectAble: isSubjectAble,
        holdersRelationship: holdersRelationship
      };
      return body;
    }

    static getPayloadForPremiumPaymentSuspension(policyNumber: string, rawValue: any) {
      const body: ISospensionePagamentiRequest = {
        policyNumber,
        scheduleDate: CommonUtils.checkAndGet(rawValue, 'scheduleDate', null)
      }

      return body
    }


    static getPayloadForVariazioneModalitaPagamento(ibanList: any[], ibanVariationForm: any, policyId: string): IVariazioneModPagamentoRequest {
      const ibanObj: IIbanObject = ibanList.find(obj => obj?.numeroRapporto === ibanVariationForm.iban.substring(10));
      const body: any = {

        iban: CommonUtils.formatIBANString(ibanObj),
        policyNumber: policyId,
        cab: ibanObj.cabRapporto,
        abi: ibanObj.abiRapporto,
      }
      return body;
    }

    static getPayloadForPremiumVariation(policyNumber: string, rawValue: any, additionalForm: any, isPolicyPrevidenziale: boolean, productCode: string) {
      let body: IVariazionePremioPeriodicitaRequest | IVariazionePremioPeriodicitaPrevidentialRequest

      if (isPolicyPrevidenziale) {
        const isOperationAmountBased = CommonUtils.checkAndGet(additionalForm, 'variationOptions', null) === EVariationOptions.PRIZE;

        const requestDay = CommonUtils.checkAndGet(rawValue, 'requestDay', null)
        const requestMonth = CommonUtils.checkAndGet(rawValue, 'requestMonth', null)

        body = {
          policyNumber: policyNumber,
          newFractionationCode: CommonUtils.checkAndGet(
            rawValue,
            'frequency',
            null
          )?.toString(),
          variationDate: CommonUtils.checkAndGet(
            rawValue,
            'variationDate',
            null
          ),
          newGrossAmount: CommonUtils.checkAndGet(rawValue, 'amount', null)?.toString(),
          ...(requestDay && { requestDay: requestDay.toString() }),
          ...(requestMonth && { requestMonth: requestMonth.toString() }),
          productCode: productCode,
          isValueChanging: isOperationAmountBased
        } as IVariazionePremioPeriodicitaPrevidentialRequest;
      } else {
        body = {
          policyNumber: policyNumber,
          frequency: CommonUtils.checkAndGet(rawValue, 'frequency', null),
          importo: CommonUtils.checkAndGet(rawValue, 'amount', null),
        } as IVariazionePremioPeriodicitaRequest;
      }

      return body;
    }

    static getPayloadForDocumentChange(
        policyNumber: string,
        rawValue: any,
        isPolicyPrevidenziale: boolean = false,
        idAnagrafico?: string,
    ): IDocumentChangeRequest {
        let body: IDocumentChangeRequest = {
            ...(!isPolicyPrevidenziale && {
              policyNumber: policyNumber,
              dateOfIssue: moment(CommonUtils.checkAndGet(rawValue, 'dataRilascio', null)).format('YYYY-MM-DDTHH:mm:ss'),
              issuingAuthority: CommonUtils.checkAndGet(rawValue, 'enteRilascio', null),
              placeOfIssue: CommonUtils.checkAndGet(rawValue, 'comuneRilascio', null),
              documentNumber: CommonUtils.checkAndGet(rawValue, 'numeroDocumento', null),
              documentType: CommonUtils.checkAndGet(rawValue, 'tipoDocumento', null),
            }),
            ...(isPolicyPrevidenziale && {
              policyNumber: policyNumber,
              documentType: CommonUtils.checkAndGet(rawValue, 'tipoDocumento', null),
              documentNumber: CommonUtils.checkAndGet(rawValue, 'documentNumber', null),
              documentReleaseDate: CommonUtils.checkAndGet(rawValue, 'documentReleaseDate', null),
              documentReleaseAuthority: CommonUtils.checkAndGet(rawValue, 'enteRilascio', null),
              documentReleasePlace: CommonUtils.checkAndGet(rawValue, 'documentReleasePlace', null),
              documentExpirationDate: CommonUtils.checkAndGet(rawValue, 'documentExpirationDate', null),
              effectDate: CommonUtils.checkAndGet(rawValue, 'effectDate', null),
              idAnagrafico: idAnagrafico
            })
        };
        return body;
    }

    static getPayloadForBranchOfficeChange(
        policyNumber: string,
        rawValue: any
    ): IBranchOfficeChangeRequest {
        let body: IBranchOfficeChangeRequest = {
            policyNumber: policyNumber,
            nuovoCab: CommonUtils.checkAndGet(rawValue, 'branchOffice', null)
        };
        return body;
    }


    static getPayloadForBeneficiaryChangePrevidential(
        policyNumber: string,
        beneficiariesList: IBeneficiarioPrevidenziale[],
        rawFirstStepForm: any
    ): IBeneficiaryChangeRequest {
        let body: any = {
            policyNumber: policyNumber,
            beneficiariesData: beneficiariesList,
            effectDate: CommonUtils.checkAndGet(rawFirstStepForm, 'effectDate', null)
        };
        return body;
    }


    static getPayloadForBeneficiaryChange(
        policyNumber: string,
        beneficiariesList: ILifeDeathBeneficiary[],
        thirdParty: IPersonDataIsv,
        ): IBeneficiaryChangeRequest {

        const normalized = beneficiariesList?.map(beneficiary => ({
            ...beneficiary,
            beneficiaryType: beneficiary.beneficiaryType?.startsWith(EBeneficiaryTypeIsv.VITA)
            ? EBeneficiaryTypeIsv.VITA
            : EBeneficiaryTypeIsv.MORTE
        }));

        const merged = Object.values(
            normalized.reduce<Record<string, ILifeDeathBeneficiary>>((acc, curr) => {
            const key = `${curr.beneficiaryCategory}-${curr.beneficiaryType}`;

            if (!acc[key]) {
                acc[key] = { ...curr };
            } else {
                acc[key].beneficiaries = [
                ...(acc[key].beneficiaries || []),
                ...(curr.beneficiaries || []),
                ];
            }

            return acc;
            }, {})
        );

        const body: IBeneficiaryChangeRequest = {
            policyNumber,
            beneficiariesData: merged,
            thirdPartyReferrer: thirdParty
        };

        return body;
    }

    static getPayloadRetirementDateVariation(
        policyNumber: string,
        rawForm: any,
    ): IRetirementDateVariation {
        let body: IRetirementDateVariation = {
            policyNumber: policyNumber,
            retirementDate: CommonUtils.checkAndGet(rawForm, 'newRetirementDate', null)
        };
        return body;
    }

    static getPayloadBankAccountChange(
      policyNumber: string,
      rawForm: any,
      ibansList: IIbanObject[]
    ): IBankAccountChangeIsvRequest {
      const iban = CommonUtils.checkAndGet(rawForm, 'iban', null);
      const selectedIbanObject: IIbanObject = ibansList.find(ibanObj => ibanObj.numeroRapporto === iban?.substring(15));
      let body: IBankAccountChangeIsvRequest = {
          policyNumber: policyNumber,
          abi: selectedIbanObject.abiRapporto,
          cab: selectedIbanObject.cabRapporto,
          contoCorrente: selectedIbanObject.numeroRapporto,
          iban: iban
      };
      return body;
    }

    static getPayloadForPayerVariation(policyNumber: string,
        data: any) : IPayerVariationUpdate {
      return {
        policyNumber: policyNumber,
        ...data
      }
    }

    static getPayloadDebitDateVariation(
        policyNumber: string,
        rawForm: any,
    ): IDebitDateVariation {
        let body: IDebitDateVariation = {
            policyNumber: policyNumber,
            debitDate: CommonUtils.checkAndGet(rawForm, 'newDebitDate', null).format('YYYY-MM-DDTHH:mm:ss'),
            effectDate: moment(CommonUtils.checkAndGet(rawForm, 'variationDate', null)).format('YYYY-MM-DDTHH:mm:ss')
        };
        return body;
    }


    static getPayloadForResidenceChange(
        policyNumber: string,
        rawValue: any,
        holderPersonType: string,
        iscritto: string,
        figureAnagrafiche: IFigureAnagrafiche[]
    ): IResidenceChangeRequest {
        let body: IResidenceChangeRequest = {
            policyNumber: policyNumber,
            personType: holderPersonType,
            country: CommonUtils.checkAndGet(rawValue, 'stato', null),
            province: CommonUtils.checkAndGet(rawValue, 'provincia', null),
            location: CommonUtils.checkAndGet(rawValue, 'localita', null),
            cap: CommonUtils.checkAndGet(rawValue, 'cap', null),
            street: CommonUtils.checkAndGet(rawValue, 'indirizzo', null),
        };
        if (iscritto) {
            body.userId = iscritto;
            body.referenceDate = CommonUtils.checkAndGet(rawValue, 'effectDate', null)//.format('YYYY-MM-DD')
            body.sameAddress = CommonUtils.checkAndGet(rawValue, 'sameAddress', false) || false;
            body.street = CommonUtils.checkAndGet(rawValue, 'indirizzo', null) + ','+ CommonUtils.checkAndGet(rawValue, 'civico', null)
            body.n_indirizzo_alternativo = Number(figureAnagrafiche.find(anagrafica => anagrafica.tipo_indirizzo === RegistryType.POSTALE).n_indirizzo_alternativo) || 0;
            if (body.country !== 'IT') {
              body.location = CommonUtils.checkAndGet(rawValue, 'stato', null);
              body.cap = '99999';
            }
        }
        return body;
    }

    static getPayloadForRegistryAdjustment(
        policyNumber: string,
        rawValue: any
    ): IRegistryAdjustmentRequest {
        let body: IRegistryAdjustmentRequest = {
            policyNumber: policyNumber,
            firstName: CommonUtils.checkAndGet(rawValue, 'nome', null),
            lastName: CommonUtils.checkAndGet(rawValue, 'cognome', null)
        };
        return body;
    }

    static getPayloadForSwitchInvestment(
        policyNumber: string,
        ndgTutoreODelegato: string,
        firstStepForm: any,
        disinvestmentFunds: IPolicyAsset[],
        investmentFunds: IPolicyAsset[],
        currentValue: string
    ): ISwitchLifeInvestmentsRequest {
        const controvaloreLineaCompagnia: string[] = [];
        const codiceLineaCompagnia: string[] = [];

        disinvestmentFunds.forEach((disinvestment) => {
            if (disinvestment.amount && parseFloat(disinvestment.amount.replace(',', '.')) > 0) {
                const disinvestedAmount = disinvestment.amount.replace(/\./g, '').replace(',', '.');
                codiceLineaCompagnia.push(disinvestment.fundCode);
                controvaloreLineaCompagnia.push('-' + disinvestedAmount);
            }
        });

        investmentFunds.forEach((investment) => {
            if (investment.amount && parseFloat(investment.amount.replace(',', '.')) > 0) {
                const investedAmount = investment.amount.replace(/\./g, '').replace(',', '.');
                codiceLineaCompagnia.push(investment.fundCode);
                controvaloreLineaCompagnia.push(investedAmount);
            }
        });

        const consultancyAmount = investmentFunds.reduce((accumulatore, valore) => {
            const numberValue = valore.amount.replace(/\./g, '').replace(',', '.')
            return accumulatore + parseFloat(numberValue);}, 0).toFixed(2).toString().replace(/\./g, ',')

        const filteredInvestmentFunds = investmentFunds.filter(fund => {
            const movementAmount = CommonUtils.checkAndGet(fund, 'amount', 0);
            return fund.amount && parseFloat(movementAmount.replace(',', '.')) > 0;
        });
        const filteredDisinvestmentFunds = disinvestmentFunds.filter(fund => {
            const movementAmount = CommonUtils.checkAndGet(fund, 'amount', 0);
            return fund.amount && parseFloat(movementAmount.replace(',', '.')) > 0;
        });

        const investments = filteredInvestmentFunds.map(fund => {
            const fundCurrentAmount = CommonUtils.checkAndGet(fund, 'currentInvestedValue', 0).toString().replace(/\./g, '').replace(',', '.');
            const movementAmount = CommonUtils.checkAndGet(fund, 'amount', "0").toString().replace(/\./g, '').replace(',', '.');
            return {
                code: fund.fundCode,
                fundCurrentAmount,
                movementAmount,
                currentPercentage: CommonUtils.checkAndGet(fund, 'percentage', 0),
                isInvestment: true
            }
        })

        const disinvestments = filteredDisinvestmentFunds.map(fund => {
            const fundCurrentAmount = CommonUtils.checkAndGet(fund, 'fundAmount', 0).toString().replace(/\./g, '').replace(',', '.');
            const movementAmount = CommonUtils.checkAndGet(fund, 'amount', "0").toString().replace(/\./g, '').replace(',', '.');
            return {
                code: fund.fundCode,
                fundCurrentAmount,
                movementAmount,
                currentPercentage: CommonUtils.checkAndGet(fund, 'percentage', 0),
                isInvestment: false
            }
        })
        const totalAmountToTransfer = CommonUtils.checkAndGet(firstStepForm, 'amount', "0").toString().replace(/\./g, '').replace(',', '.');

        let body: ISwitchLifeInvestmentsRequest = {
            policyNumber: policyNumber,
            ndgTutoreODelegato,
            investmentFunds: [...disinvestments, ...investments],
            currentValue: currentValue,
            totalAmountToTransfer: totalAmountToTransfer,
            codiceLineaCompagnia,
            controvaloreLineaCompagnia,
            consultancyAmount: consultancyAmount
        };
        return body;
    }

    static getPayloadForSwitchInvestmentPrevidenziale(
        policyNumber: string,
        firstStepForm: any,
        disinvestmentFunds: IPolicyAsset[],
        investmentFunds: IPolicyAsset[]
    ) {
        // const totalAmountToTransfer = parseFloat(CommonUtils.checkAndGet(firstStepForm, 'amount', "0").toString().replace(/\./g, '').replace(',', '.'));
        const selectedFund = disinvestmentFunds.find(fund => fund.selected);

        const investedFunds: PrevidentialInvestedFund[] = investmentFunds.map(fund => {
            // const amountToInvest = parseFloat(CommonUtils.checkAndGet(fund, 'amount', "0").toString().replace(/\./g, '').replace(',', '.'));
            return {
                c_compagnia: 'V',
                c_fondo: fund.fundCode,
                c_garanzia: selectedFund.assuranceCode,
                descrizione: fund.description,
                p_investimento: fund.pInvestment.replace(',', '.'),
            }
        })

        const filteredInvestedFunds = investedFunds.filter(fund => {
            return fund.p_investimento && parseFloat(fund.p_investimento) > 0;
        });
        const investmentRequest: PrevidentialInvestmentMovement = {
            cFondoDA: selectedFund?.fundCode,
            descrizione: selectedFund?.description,
            fondoA: filteredInvestedFunds
        }

        let body: ISwitchPrevidentialInvestmentsRequest = {
            policyNumber: policyNumber,
            investmentRequest
        }
        return body;
    }

    static getPayloadForChangeInvestmentLine(
        policyNumber: string,
        ndgTutoreODelegato: string,
        rawValue: any,
        lines: IInvestmentLine[],
        insuredAmount: string
    ): IChangeLineInvestmentRequest {
        let codiceLineaCompagnia: string[] = [];
        let controvaloreLineaCompagnia: string[] = [];

        // Linea di investimento selezionata
        const selectedLine = lines.find(line => line.code === CommonUtils.checkAndGet(rawValue, 'line', null));

        const sourceLine = lines.find(line => line.selected);
        // Linea di investimento di provenienza
        codiceLineaCompagnia.push(selectedLine.code);
        codiceLineaCompagnia.push(sourceLine.code);

        const consultancyAmount = parseFloat(insuredAmount).toFixed(2).replace(/\./g, ',')

        controvaloreLineaCompagnia.push(consultancyAmount)
        controvaloreLineaCompagnia.push('-'+ consultancyAmount)

        let body: IChangeLineInvestmentRequest = {
            policyNumber: policyNumber,
            selectedLine: {
                code: CommonUtils.checkAndGet(selectedLine, 'code', null),
                funds: selectedLine.funds.map(fund=>({
                    code: fund.fundCode,
                    description: fund.description,
                    fundAmount: fund.fundAmount,
                    percentage: fund.percentage
                }))
            },
            ndgTutoreODelegato,
            codiceLineaCompagnia,
            controvaloreLineaCompagnia,
            consultancyAmount
        };
        return body;
    }

    static getPayloadForChangeInvestmentLinePrevidential(
        policyNumber: string,
        rawValue: any,
        lines: IInvestmentLine[],
        emissionDate: string,
        expiryDate: string
    ) {
        const currentLineFunds = lines.find(line => line.selected).funds;
        const newLineFunds = lines.find(line => line.code === CommonUtils.checkAndGet(rawValue, 'destinationLine', null))?.funds;
        const newFunds: FundObject[] = newLineFunds?.map(fund => {
            return {
                cCompagnia: 'V',
                cFondo: fund.fundCode,
                cTipoContributo: 'I',
                descrizione: fund.description,
                dFine: expiryDate === 'N/A' ? "2050-12-31T00:00:00" : expiryDate,
                dInizio: emissionDate,
                nPolizza: policyNumber,
                nPosizione: "0",
                pInvestimento: 100
            }
        });

        const fondoA = newLineFunds?.map(fund => {
            return {
                c_compagnia: 'V',
                c_fondo: fund.fundCode,
                c_garanzia: currentLineFunds[0].assuranceCode,
                descrizione: fund.description,
                p_investimento: "100",
                c_tipo_classe: "I"
            }
        });

        const switchFundsMovement: PrevidentialInvestmentMovement[] = currentLineFunds?.map(fund => {
            return {
                cFondoDA: fund.fundCode,
                descrizione: fund.description,
                tipoClasse: 'I',
                fondoA
            }
        });

        let body: IChangeLineInvestmentPrevidentialRequest = {
            policyNumber,
            newInvestmentLine: CommonUtils.checkAndGet(rawValue, 'destinationLine', null),
            newFunds,
            switchFundsMovement
        };
        return body;
    }

    static getPayloadForReindirizzamentoFondi(
        policyNumber: string,
        investmentFunds: IPolicyAsset[],
        emissionDate: string,
        expiryDate: string
    ): { policyNumber: string; funds: FundObject[] } {
        const funds = [];
        investmentFunds.forEach(fund => {
            funds.push({
                cCompagnia: 'V',
                cFondo: fund.fundCode,
                cTipoContributo: 'A',
                descrizione: fund.description,
                // dFine: expiryDate === 'N/A' ? "2050-12-31T00:00:00" : expiryDate,
                // dInizio: emissionDate,
                nPolizza: policyNumber,
                nPosizione: "0",
                pInvestimento: fund.companyAllocation.replace(',', '.')
            });
            funds.push({
                cCompagnia: 'V',
                cFondo: fund.fundCode,
                cTipoContributo: 'I',
                descrizione: fund.description,
                // dFine: expiryDate === 'N/A' ? "2050-12-31T00:00:00" : expiryDate,
                // dInizio: emissionDate,
                nPolizza: policyNumber,
                nPosizione: "0",
                pInvestimento: fund.subscriberAllocation.replace(',', '.')
            });
            funds.push({
                cCompagnia: 'V',
                cFondo: fund.fundCode,
                cTipoContributo: 'T',
                descrizione: fund.description,
                // dFine: expiryDate === 'N/A' ? "2050-12-31T00:00:00" : expiryDate,
                // dInizio: emissionDate,
                nPolizza: policyNumber,
                nPosizione: "0",
                pInvestimento: fund.TFRAllocation.replace(',', '.')
            });
        });
        let body: { policyNumber: string; funds: FundObject[] } = {
            policyNumber,
            funds
        };
        return body;
    }

    static getPayloadForAnnulloOperazione(
        policyNumber: string,
        movementId: string
    ): IAnnulloOperazione {
        let body: IAnnulloOperazione = {
            policyNumber: policyNumber,
            movementId: movementId
        };
        return body;
    }

    static getPayloadForComunicazioneSinistro(
        policyNumber: string,
        insuredRawValue: any,
        declarantRawValue: any,
        policyHolderData: any
    ): IComunicazioneSinistroRequest {
      const policyInsured = {
        personType: 'PF',
        taxOrVatCode: CommonUtils.checkAndGet(insuredRawValue, 'codiceFiscale', null),
        firstName: CommonUtils.checkAndGet(insuredRawValue, 'nome', null),
        lastName: CommonUtils.checkAndGet(insuredRawValue, 'cognome', null)
      };
      const declarantPersonType = CommonUtils.checkAndGet(declarantRawValue, 'naturaGiuridica', null) === 'personaFisica'
          ? 'Fisica'
          : 'Giuridica';
      const isDeclarantPF: boolean = declarantPersonType === 'Fisica';
      const declarant = {
        personType: declarantPersonType,
        taxOrVatCode: isDeclarantPF
          ? CommonUtils.checkAndGet(declarantRawValue, 'codiceFiscale', null)
          : CommonUtils.checkAndGet(declarantRawValue, 'partitaIva', null),
        firstName: isDeclarantPF
          ? CommonUtils.checkAndGet(declarantRawValue, 'nome', null)
          : null,
        lastName: isDeclarantPF
          ? CommonUtils.checkAndGet(declarantRawValue, 'cognome', null)
          : null,
        ragioneSociale: isDeclarantPF
          ? CommonUtils.checkAndGet(declarantRawValue, 'ragioneSociale', null)
          : null
      };
      const holderPersonType = CommonUtils.checkAndGet(policyHolderData, 'codiceFiscale', null)
          ? 'Fisica'
          : 'Giuridica';
      const isPolicyHolderPF: boolean = holderPersonType === 'Fisica';
      const policyHolder = {
        personType: holderPersonType,
        taxOrVatCode: isPolicyHolderPF
          ? CommonUtils.checkAndGet(policyHolderData, 'codiceFiscale', null)
          : CommonUtils.checkAndGet(policyHolderData, 'partitaIva', null),
        firstName: isPolicyHolderPF
          ? CommonUtils.checkAndGet(policyHolderData, 'nome', null)
          : null,
        lastName: isPolicyHolderPF
          ? CommonUtils.checkAndGet(policyHolderData, 'cognome', null)
          : null,
        ragioneSociale: isPolicyHolderPF
          ? CommonUtils.checkAndGet(policyHolderData, 'ragioneSociale', null)
          : null
      };
      let body: IComunicazioneSinistroRequest = {
          policyNumber: policyNumber,
          policyInsured: policyInsured,
          declarant: declarant,
          policyHolder: policyHolder,
          dateOfDeath: moment(CommonUtils.checkAndGet(insuredRawValue, 'dataDecesso', null)).format('YYYY-MM-DDTHH:mm:ss')
      };
      return body;
    }
    // endregion

    // region GIANOS DATA

    static getGianosPolicyHolderData(
      registryRawValue: any,
      documentRawValue: any,
      businessRawValue: any,
      residenceRawValue: any,
      addressRawValue: any
    ): IGianosPolicyHolder {
      let policyHolder: IGianosPolicyHolder = null;
      if ('partitaIva' in registryRawValue) {
        // se PG
        policyHolder = {
          capSedeLegale: CommonUtils.checkAndGet(residenceRawValue, 'cap', null),
          classeBeneficiariSuCuiSiRivolgonoLeAttivita: CommonUtils.checkAndGet(businessRawValue, 'classeBeneficiariSuCuiSiRivolgonoLeAttivita', null),
          codiceATECO: CommonUtils.checkAndGet(businessRawValue, 'codiceAteco', null),
          comuneSedeLegale: CommonUtils.checkAndGet(residenceRawValue, 'localita', null),
          dataCostituzione: moment(CommonUtils.checkAndGet(registryRawValue, 'dataNascita', null)).format('YYYY-MM-DDTHH:mm:ss'),
          indirizzoSedeLegale: CommonUtils.checkAndGet(residenceRawValue, 'indirizzo', null),
          partitaIVA: CommonUtils.checkAndGet(registryRawValue, 'partitaIva', null),
          provinciaSedeLegale: CommonUtils.checkAndGet(residenceRawValue, 'provincia', null),
          ragioneSociale: CommonUtils.checkAndGet(registryRawValue, 'denominazione', null) || CommonUtils.checkAndGet(registryRawValue, 'ragioneSociale', null),
          statoEsteroSedeLegale: CommonUtils.checkAndGet(residenceRawValue, 'stato', null),
          tipoSocietaImpresa: CommonUtils.checkAndGet(businessRawValue, 'tipoSocietaImpresa', null),
          presenzaNelleListeEsterne: CommonUtils.checkAndGet(registryRawValue, 'presenzaListaEsterne', null),
          codiceSAE: CommonUtils.checkAndGet(businessRawValue, 'codiceSae', null),
          fasciaRedditoFatturatoContraente: CommonUtils.checkAndGet(businessRawValue, 'fasciaReddito', null),
        }
      } else {
        // se PF
        policyHolder = {
          nome: CommonUtils.checkAndGet(registryRawValue, 'nome', null),
          cognome: CommonUtils.checkAndGet(registryRawValue, 'cognome', null),
          codiceFiscale: CommonUtils.checkAndGet(registryRawValue, 'codiceFiscale', null),
          sesso: CommonUtils.checkAndGet(registryRawValue, 'sesso', null),
          dataNascita: moment(CommonUtils.checkAndGet(registryRawValue, 'dataNascita', null)).format('YYYY-MM-DDTHH:mm:ss'),
          luogoNascita: CommonUtils.checkAndGet(registryRawValue, 'comuneNascita', null),
          provinciaNascita: CommonUtils.checkAndGet(registryRawValue, 'provinciaNascita', null),
          statoEsteroNascita: CommonUtils.checkAndGet(registryRawValue, 'statoNascita', null),
          cittadinanza1: CommonUtils.checkAndGet(registryRawValue, 'cittadinanza', null),
          cittadinanza2: CommonUtils.checkAndGet(registryRawValue, 'secondaCittadinanza', null),
          indirizzoResidenza: CommonUtils.checkAndGet(residenceRawValue, 'indirizzo', null),
          comuneResidenza: CommonUtils.checkAndGet(residenceRawValue, 'localita', null),
          capResidenza: CommonUtils.checkAndGet(residenceRawValue, 'cap', null),
          provinciaResidenza: CommonUtils.checkAndGet(residenceRawValue, 'provincia', null),
          statoEsteroResidenza: CommonUtils.checkAndGet(residenceRawValue, 'stato', null),
          presenzaNelleListeEsterne: CommonUtils.checkAndGet(registryRawValue, 'presenzaListaEsterne', null),
          codiceSAE: CommonUtils.checkAndGet(businessRawValue, 'codiceSae', null),
          codiceATECO: CommonUtils.checkAndGet(businessRawValue, 'codiceAteco', null),
          codiceTAE: CommonUtils.checkAndGet(businessRawValue, 'codiceTae', null),
          fasciaRedditoFatturatoContraente: CommonUtils.checkAndGet(businessRawValue, 'fasciaReddito', null),
          tipologiaAttivita: CommonUtils.checkAndGet(businessRawValue, 'activityType', null),
          documentoIdentita: CommonUtils.checkAndGet(documentRawValue, 'tipoDocumento', null),
          numeroDocumentoIdentita: CommonUtils.checkAndGet(documentRawValue, 'numeroDocumento', null),
          dataRilascioDocumento: moment(CommonUtils.checkAndGet(documentRawValue, 'dataRilascio', null)).format('YYYY-MM-DDTHH:mm:ss'),
          rilasciatoDa: CommonUtils.checkAndGet(documentRawValue, 'enteRilascio', null),
        }
      }
      if (policyHolder) {
        policyHolder = {
          ...policyHolder,
          comuneRecapito: CommonUtils.checkAndGet(addressRawValue, 'localita', null),
          capRecapito: CommonUtils.checkAndGet(addressRawValue, 'cap', null),
          indirizzoRecapito: CommonUtils.checkAndGet(addressRawValue, 'indirizzo', null),
          provinciaRecapito: CommonUtils.checkAndGet(addressRawValue, 'provincia', null),
          statoEsteroRecapito: CommonUtils.checkAndGet(addressRawValue, 'stato', null)
        }
      }
      return policyHolder;
    }

    static getGianosInsuredData(insuredRawValue: any): IGianosPolicyInsured {
      let insured: IGianosPolicyInsured = null;
      insured = {
        nome: CommonUtils.checkAndGet(insuredRawValue, 'name', null),
        cognomeDenominazioneSociale: CommonUtils.checkAndGet(insuredRawValue, 'surname', null),
        dataNascitaCostituzione: moment(CommonUtils.checkAndGet(insuredRawValue, 'birthDate', null)).format('YYYY-MM-DDTHH:mm:ss'),
        codiceFiscale: CommonUtils.checkAndGet(insuredRawValue, 'fiscalCode', null),
        presenzaListeEsterne: CommonUtils.checkAndGet(insuredRawValue, 'isPEP', null),
        luogoNascitaCostituzione: CommonUtils.checkAndGet(insuredRawValue, 'birthPlace', null)
      }
      return insured;
    }

    static getGianosBeneficiary(beneficiaryRawValue: any): IGianosDesignazioneBeneficiari[] {
      const designazioneBeneficiarioIndividuato: string = CommonUtils.checkAndGet(beneficiaryRawValue, 'designatedBeneficiary', null);
      let beneficiary: IGianosDesignazioneBeneficiari = null;
      if (designazioneBeneficiarioIndividuato === 'NO') {
        beneficiary = {
          designazioneBeneficiarioIndividuato: designazioneBeneficiarioIndividuato,
          descrizione: CommonUtils.checkAndGet(beneficiaryRawValue, 'description', null)
        }
      } else {
        const beneficiaryType = CommonUtils.checkAndGet(beneficiaryRawValue, 'beneficiaryType', null);
        if (beneficiaryType === ESpecificBeneficiaryType.PERSONA_FISICA) {
          beneficiary = {
            designazioneBeneficiarioIndividuato: CommonUtils.checkAndGet(beneficiaryRawValue, 'designatedBeneficiary', null),
            nome: CommonUtils.checkAndGet(beneficiaryRawValue, 'name', null),
            codiceFiscale: CommonUtils.checkAndGet(beneficiaryRawValue, 'fiscalCode', null),
            dataNascitaCostituzione: CommonUtils.checkAndGet(beneficiaryRawValue, 'birthDate', null),
            luogoNascitaCostituzione: CommonUtils.checkAndGet(beneficiaryRawValue, 'birthPlace', null),
            cognomeDenominazioneSociale: CommonUtils.checkAndGet(beneficiaryRawValue, 'surname', null),
          }
        } else {
          beneficiary = {
            designazioneBeneficiarioIndividuato: CommonUtils.checkAndGet(beneficiaryRawValue, 'designatedBeneficiary', null),
            dataNascitaCostituzione: CommonUtils.checkAndGet(beneficiaryRawValue, 'companyDate', null),
            luogoNascitaCostituzione: CommonUtils.checkAndGet(beneficiaryRawValue, 'companyPlace', null),
            cognomeDenominazioneSociale: CommonUtils.checkAndGet(beneficiaryRawValue, 'companyName', null),
            partitaIVA: CommonUtils.checkAndGet(beneficiaryRawValue, 'vatCode', null)
          }
        }
        beneficiary.relazioneContraenteBeneficiario = CommonUtils.checkAndGet(beneficiaryRawValue, 'beneficiaryContractorRelationship', null);
	      beneficiary.relazioneAssicuratoBeneficiario = CommonUtils.checkAndGet(beneficiaryRawValue, 'beneficiaryInsuredRelationship', null);
      }
      return [beneficiary];
    }

    static getGianosTitolariEffettivi(effectiveOwnersList: IPersonIntestaFormGroups[]): IGianosTitolareEffettivo[] {
      const titolariEffettivi: IGianosTitolareEffettivo[] = effectiveOwnersList.map((owner: IPersonIntestaFormGroups) => {
        const registryRawValue = CommonUtils.checkAndGet(owner, 'registryForm', null)?.getRawValue();
        const residenceRawValue = CommonUtils.checkAndGet(owner, 'residenceForm', null)?.getRawValue();
        const documentRawValue = CommonUtils.checkAndGet(owner, 'identificationDocumentForm', null)?.getRawValue();
        return {
          nome: CommonUtils.checkAndGet(registryRawValue, 'nome', null),
          cognome: CommonUtils.checkAndGet(registryRawValue, 'cognome', null),
          codiceFiscale: CommonUtils.checkAndGet(registryRawValue, 'codiceFiscale', null),
          sesso: CommonUtils.checkAndGet(registryRawValue, 'sesso', null),
          dataNascita: moment(CommonUtils.checkAndGet(registryRawValue, 'dataNascita', null)).format('YYYY-MM-DDTHH:mm:ss'),
          luogoNascita: CommonUtils.checkAndGet(registryRawValue, 'comuneNascita', null),
          provinciaNascita: CommonUtils.checkAndGet(registryRawValue, 'provinciaNascita', null),
          statoEsteroNascita: CommonUtils.checkAndGet(registryRawValue, 'statoNascita', null),
          comuneResidenza: CommonUtils.checkAndGet(residenceRawValue, 'localita', null),
          indirizzoResidenza: CommonUtils.checkAndGet(residenceRawValue, 'indirizzo', null),
          capResidenza: CommonUtils.checkAndGet(residenceRawValue, 'cap', null),
          provinciaResidenza: CommonUtils.checkAndGet(residenceRawValue, 'provincia', null),
          statoEsteroResidenza: CommonUtils.checkAndGet(residenceRawValue, 'stato', null),
          documentoIdentita: CommonUtils.checkAndGet(documentRawValue, 'tipoDocumento', null),
          numeroDocumentoIdentita: CommonUtils.checkAndGet(documentRawValue, 'numeroDocumento', null),
          dataRilascioDocumento: moment(CommonUtils.checkAndGet(documentRawValue, 'dataRilascio', null)).format('YYYY-MM-DDTHH:mm:ss'),
          rilasciatoDa: CommonUtils.checkAndGet(documentRawValue, 'enteRilascio', null),
          cittadinanza1: CommonUtils.checkAndGet(registryRawValue, 'cittadinanza', null),
          cittadinanza2: CommonUtils.checkAndGet(registryRawValue, 'secondaCittadinanza', null),
          presenzaNelleListeEsterne: CommonUtils.checkAndGet(registryRawValue, 'isPEP', null),
        }
      });
      return titolariEffettivi;
    }

    static getGianosOperationData(
      operationDataRawValue: any,
      controvalore: string,
      agreementPurpose: any
    ): IGianosOperationInfo {
      const scopoRapporto: string = agreementPurpose?.find(item => item.key === CommonUtils.checkAndGet(operationDataRawValue, 'reportScope', null))?.value;
      const operationInfo: IGianosOperationInfo = {
        numeroAgenzia: CommonUtils.checkAndGet(operationDataRawValue, 'agencyCode', null),
        numeroPropostaPolizza: CommonUtils.checkAndGet(operationDataRawValue, 'policyNumber', null),
        mezziPagamento: CommonUtils.checkAndGet(operationDataRawValue, 'paymentType', null),
        paeseProvenienzaDestinazioneFondi: CommonUtils.checkAndGet(operationDataRawValue, 'fundOriginCountry', null),
        origineFondi: CommonUtils.checkAndGet(operationDataRawValue, 'fundOrigin', null),
        notaOrigineFondi: CommonUtils.checkAndGet(operationDataRawValue, 'fundOriginNote', null),
        importoOperazione: controvalore,
        liquidazione: CommonUtils.checkAndGet(operationDataRawValue, 'liquidationMaturity', null),
        scopoRapporto: scopoRapporto
      }
      return operationInfo
    }

    static getGianosOperatorData(
      operatorDataRawValue: any,
      registryRawValue: any,
    ): IGianosDatiOperatore {
      const operatorData: IGianosDatiOperatore = {
        dataSottoscrizioneRilevatore: moment(CommonUtils.checkAndGet(operatorDataRawValue, 'subscriptionDate', null)).format('YYYY-MM-DDTHH:mm:ss'),
        comportamentoTenutoCliente: CommonUtils.checkAndGet(registryRawValue, 'comportamentoCliente', null)
      }
      return operatorData;
    }

    static getGianosRappresentanteLegale(
      legalGuardianRegistryRawValue: any,
      legalGuardianResidenceRawValue: any,
      legalGuardianIdentificationDocumentRawValue: any,
    ): IGianosEsecutoreConto {
      const esecutoreConto: IGianosEsecutoreConto = {
        nome: CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'nome', null),
        cognome: CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'cognome', null),
        sesso: CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'sesso', null),
        codiceFiscale: CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'codiceFiscale', null),
        dataNascita: moment(CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'dataNascita', null)).format('YYYY-MM-DDTHH:mm:ss'),
        luogoNascita: CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'comuneNascita', null),
        provinciaNascita: CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'provinciaNascita', null),
        statoEsteroNascita: CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'statoNascita', null),
        cittadinanza1: CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'cittadinanza', null),
        cittadinanza2: CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'secondaCittadinanza', null),
        indirizzoResidenza: CommonUtils.checkAndGet(legalGuardianResidenceRawValue, 'indirizzo', null),
        comuneResidenza: CommonUtils.checkAndGet(legalGuardianResidenceRawValue, 'localita', null),
        capResidenza: CommonUtils.checkAndGet(legalGuardianResidenceRawValue, 'cap', null),
        provinciaResidenza: CommonUtils.checkAndGet(legalGuardianResidenceRawValue, 'provincia', null),
        statoEsteroResidenza: CommonUtils.checkAndGet(legalGuardianResidenceRawValue, 'stato', null),
        presenzaNelleListeEsterne: CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'presenzaListaEsterne', null),
        documentoIdentita: CommonUtils.checkAndGet(legalGuardianIdentificationDocumentRawValue, 'tipoDocumento', null),
        numeroDocumentoIdentita: CommonUtils.checkAndGet(legalGuardianIdentificationDocumentRawValue, 'numeroDocumento', null),
        dataRilascioDocumento: moment(CommonUtils.checkAndGet(legalGuardianIdentificationDocumentRawValue, 'dataRilascio', null)).format('YYYY-MM-DDTHH:mm:ss'),
        rilasciatoDa: CommonUtils.checkAndGet(legalGuardianIdentificationDocumentRawValue, 'enteRilascio', null),
        relazioneContraenteEsecutore: CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'relazioneContraenteEsecutore', null),
        tipoDelega: CommonUtils.checkAndGet(legalGuardianRegistryRawValue, 'tipoDelega', null)
      };
      return esecutoreConto;
    }

    static getGianosPaymentMode(
      operationDataRawValue: any,
      iban: string,
      ibanList: IIbanObject[],
      counterValue: string
    ): IGianosPaymentMode {
      const ibanValue: string = iban;
      const ibanObj: IIbanObject = ibanList.find(obj => obj?.numeroRapporto === ibanValue.substring(10));
      const paymentMode: IGianosPaymentMode = {
        code: CommonUtils.checkAndGet(operationDataRawValue, 'paymentType', null),
        iban: CommonUtils.formatIBANString(ibanObj),
        amount: counterValue,
        bic: CommonUtils.checkAndGet(ibanObj, 'codiceBIC', null)
      }
      return paymentMode;
    }

    static getGianosFundsList(activeFunds: IPolicyAsset[]): IGianosFunsList[] {
      if (activeFunds?.length > 0) {
        const filteredActiveFunds = activeFunds.filter(fund => {
          let amount: string = CommonUtils.checkAndGet(fund, 'amount', null);
          amount = amount?.toString().replace(/\./g, '');
          amount = amount?.replace(/\,/g, '.');
          return fund && parseFloat(amount) > 0;
        });
        return filteredActiveFunds.map((fund: IPolicyAsset) => {
          let amount: string = CommonUtils.checkAndGet(fund, 'amount', null);
          amount = amount?.toString().replace(/\./g, '');
          amount = amount?.replace(/\,/g, '.');
          let fundAmount: string = CommonUtils.checkAndGet(fund, 'fundAmount', null);
          fundAmount = fundAmount?.toString().replace(/\./g, '');
          fundAmount = fundAmount?.replace(/\,/g, '.');
          return {
            fundCode: CommonUtils.checkAndGet(fund, 'fundCode', null),
            amount: amount,
            numberOfQuotes: CommonUtils.checkAndGet(fund, 'quoteNumber', null),
            quoteValue: CommonUtils.checkAndGet(fund, 'quoteValue', null),
            currentValue: fundAmount,
          }
        });
      }
    }

    static getContractorGianosAdequateVerification(
      adequateVerificationRawValue: any,
      fiscalCode: string,
      chargeTypes: any[]
    ): IGianosAdequateVerification {
      const filledPositions: string[] = [];
      if (chargeTypes) {
        chargeTypes.forEach((chargeType: any) => {
          const key = chargeType.key;
          if (CommonUtils.checkAndGet(adequateVerificationRawValue, key, null)) {
            filledPositions.push(key);
          }
        })
      }
      const adequateVerification: IGianosAdequateVerification = {
        riskCode: 'A',
        incomeLevel: CommonUtils.checkAndGet(adequateVerificationRawValue, 'fasciaReddito', null),
        interestInPublicFunds: CommonUtils.checkAndGet(adequateVerificationRawValue, 'publicFunds', null),
        isPoliticallyExposed: CommonUtils.checkAndGet(adequateVerificationRawValue, 'isPEP', false),
        professionCode: CommonUtils.checkAndGet(adequateVerificationRawValue, 'profession', null),
        taxOrVatCode: fiscalCode,
        filledPositions: filledPositions
      };
      return adequateVerification;
    }

    static getGianosAdequateVerification(
      adequateVerificationRawValue: any,
      fiscalCode: string
    ): IGianosAdequateVerification {
      const adequateVerification: IGianosAdequateVerification = {
        isPoliticallyExposed: CommonUtils.checkAndGet(adequateVerificationRawValue, 'isPEP', false),
        professionCode: CommonUtils.checkAndGet(adequateVerificationRawValue, 'profession', null),
        taxOrVatCode: fiscalCode
      };
      return adequateVerification;
    }

    static getTutorsGianosAdequateVerification(
      effectiveOwnersList: any
    ): IGianosAdequateVerification[] {
      const adequateVerificationArray: IGianosAdequateVerification[] = [];
      effectiveOwnersList.forEach((owner: IPersonIntestaFormGroups) => {
        adequateVerificationArray.push(this.getGianosAdequateVerification(
          CommonUtils.checkAndGet(owner, 'properVerificationForm', null)?.getRawValue,
          CommonUtils.checkAndGet(owner, 'registryForm.fiscalCode', null)?.getRawValue,
        )
      )});
      return adequateVerificationArray;
    }

    static getGianosPrivacy(
      adequateVerificationRawValue: any,
      isLegalSubject: boolean
    ): IGianosPrivacy {
      let privacy: IGianosPrivacy = null;
      if (isLegalSubject) {
        privacy = {
          commercialePGDati: CommonUtils.checkAndGet(adequateVerificationRawValue, 'privacy1', null)
        }
      } else {
        privacy = {
          datiSensibili: CommonUtils.checkAndGet(adequateVerificationRawValue, 'privacy3', null),
          contrattuale: CommonUtils.checkAndGet(adequateVerificationRawValue, 'privacy1', null),
          commerciale: CommonUtils.checkAndGet(adequateVerificationRawValue, 'privacy2', null)
        };
      }
      return privacy;
    }

    // endregion

}
